// i18n.pl.js — słownik POLSKI (język domyślny). Teksty 1:1 z kodu sprzed MONITU
// 2026-10-02_0526 (polski nie zmienia się ani o znak). Klucz = 'obszar.element'.
// Wartość: string ze wstawkami {x} albo obiekt form liczby mnogiej { one, few, many }.
// Każdy klucz MUSI mieć odpowiednik w i18n.de.js (test i18n.test.js). Nowy slot = nowy
// klucz slot.<slot_key> w OBU plikach.
/* eslint-disable quotes */

export const PL = {
  // ─── wspólne ──────────────────────────────────────────────────────────────
  'common.cancel': 'Anuluj',
  'common.ok': 'OK',
  'common.close': 'Zamknij',
  'common.back': 'Wstecz',
  'common.save': 'Zapisz',
  'common.change': 'Zmień',
  'common.delete': 'Usuń',
  'common.retry': 'Ponów',
  'common.yes': 'Tak',
  'common.no': 'Nie',
  'common.loading': 'Ładowanie…',
  'common.saving': 'Zapisuję…',
  'common.refresh': 'Odśwież',
  'common.understood': 'Rozumiem',
  'common.tryAgain': 'Spróbuj ponownie.',
  'common.unknown': 'nieznany',
  'common.none': 'brak',

  // ─── język / motyw ────────────────────────────────────────────────────────
  'lang.toggleAria': 'Przełącz język (PL / DE)',
  'lang.toggleTitle': 'Język / Sprache',
  'theme.toLightAria': 'Przełącz na jasny motyw',
  'theme.toDarkAria': 'Przełącz na ciemny motyw',
  'theme.lightTitle': 'Jasny motyw',
  'theme.darkTitle': 'Ciemny motyw',
  'theme.dark': 'Ciemny',
  'theme.light': 'Jasny',

  // ─── App.jsx ──────────────────────────────────────────────────────────────
  'app.notFound': '404: nie znaleziono',
  'app.backHome': 'Wróć do strony głównej',

  // ─── netErrors.js ─────────────────────────────────────────────────────────
  'net.offline': 'Brak połączenia. Zmiana nie została zapisana, spróbuj ponownie przy lepszym zasięgu.',
  'net.saveFailed': 'Nie udało się zapisać',
  'net.failedWithCode': '{action} ({code}). Spróbuj ponownie.',
  'net.failedPlain': '{action}. Spróbuj ponownie.',
  'err.duplicate_photo': 'To zdjęcie już jest w innym slocie tego adresu (duplikat).',
  'err.image_too_small': 'Zdjęcie jest za małe (min. 1000 px i 50 KB). Zrób nowe aparatem, nie z miniatury.',
  'err.forbidden': 'Ten adres jest przypisany do innego zespołu. Zadzwoń do Martina, on odblokuje adres.',
  'err.forbidden_support_role': 'Konto serwisowe nie ma uprawnień do tej operacji.',
  'err.admin_cannot_configure': 'Konto podglądowe nie może zmieniać danych.',
  'err.slot_not_found': 'Slot nie istnieje (odśwież ekran).',
  'err.photo_not_found': 'Zdjęcie już nie istnieje (odśwież ekran).',
  'err.not_found': 'Nie znaleziono (odśwież ekran).',
  'err.unauthorized': 'Sesja wygasła. Zaloguj się ponownie.',

  // ─── uploadErrors.js ──────────────────────────────────────────────────────
  'upErr.image_too_small': 'Zdjęcie odrzucone: to pomniejszona kopia (miniatura z galerii/komunikatora). Minimum: dłuższy bok 1000 px i 50 KB. Wybierz oryginał w pełnej rozdzielczości.',
  'upErr.duplicate_photo': 'Zdjęcie odrzucone: DUPLIKAT, ten sam plik już jest w systemie.',
  'upErr.address_not_found': 'Adres poza oknem tygodni uploadu albo należy do innego teamu. Jeśli to Twój adres, zgłoś do biura (okno KW).',
  'upErr.forbidden': 'Adres należy do innego zespołu, upload zablokowany.',
  'upErr.forbidden_support_role': 'Konto serwisowe nie może wgrywać zdjęć na tym adresie.',
  'upErr.address_missing_or_invalid_ausbauTermin': 'Adres nie ma poprawnego terminu montażu (Ausbau Termin) w Airtable. Zgłoś do biura.',
  'upErr.address_missing_team': 'Adres nie ma przypisanego teamu w Airtable. Zgłoś do biura.',
  'upErr.address_no_projekt_link': 'Adres nie ma przypisanego projektu w Airtable. Zgłoś do biura.',
  'upErr.file_too_large': 'Plik jest za duży (limit 20 MB).',
  'upErr.offline': 'Brak internetu. Zdjęcie czeka w kolejce i wyśle się samo po odzyskaniu zasięgu.',
  'upErr.server': 'Błąd serwera. Spróbuj ponownie za chwilę.',
  'upErr.serverWithCode': '{server} (kod: HTTP {status})',
  'upErr.unknown': 'Zdjęcie odrzucone (kod: {code}). Spróbuj ponownie; jeśli się powtarza, podaj ten kod Martinowi.',
  'photo.tooSmall': 'To pomniejszona kopia zdjęcia (np. zapisana z komunikatora). Wybierz oryginał w pełnej rozdzielczości.',

  // ─── formatSyncResult.js ──────────────────────────────────────────────────
  'sync.noResult': 'OneDrive: brak wyniku',
  'sync.held': '⛔ Sync wstrzymany: {n} slot(y) bez zatwierdzenia AI. Sprawdź czerwone/szare kafelki',
  'sync.withErrors': 'OneDrive ⚠ skopiowane {synced}/{total}, błędów: {errs}',
  'sync.allDoneLink': '✅ Wszystko już na OneDrive, link folderu uzupełniony',
  'sync.allDone': '✅ Wszystko już zsynchronizowane na OneDrive',
  'sync.copied': '✅ OneDrive: skopiowane {synced}/{total}',
  'sync.queued': '⏳ W kolejce do OneDrive{pos}',
  'sync.queuedPos': ' (pozycja {pos})',
  'sync.running': '🔄 Kopiowanie… {copied}{total}',
  'sync.failed': '❌ Błąd przy {copied}{total}: {error}',

  // ─── appVersion.js (baner wersji) ─────────────────────────────────────────
  'ver.ready': '🔄 Nowa wersja gotowa{t}',
  'ver.downloading': '⬇ Pobieram nową wersję{t}{p}, dokończy się przy zasięgu',
  'ver.required': 'Wymagana aktualizacja{t}. Pliki są już w telefonie, wystarczy jedno tapnięcie.',
  'ver.requiredPartial': '⚠ Wymagana aktualizacja{t}{p}, dokończ przy zasięgu. Możesz pracować.',

  // ─── queueHealth.js (stopka kolejki) ──────────────────────────────────────
  'queue.photos': { one: 'zdjęcie', few: 'zdjęcia', many: 'zdjęć' },
  'queue.lastSent': 'ostatnie wysłane {ago}',
  'queue.nothingSent': 'nic jeszcze nie wysłano',
  'queue.waiting': '⏳ {total} {photos} czeka{f} · {tail}',
  'queue.allSentAgo': '✓ wszystko wysłane · ostatnie {ago}',
  'queue.allSent': '✓ wszystko wysłane',

  // ─── useApi.js ────────────────────────────────────────────────────────────
  'api.noLocalData': 'Brak danych lokalnych dla tego adresu. Włącz synchronizację albo otwórz adres przy zasięgu.',
  'api.weakSignal': 'Słaby zasięg: serwer nie odpowiedział w 6 s. Spróbuj ponownie przy lepszym zasięgu.',

  // ─── weTypeSheet.js / bsCodes.js (etykiety typów i slotów BS) ─────────────
  'weType.t1.label': 'Typ-1 (Rurki)',
  'weType.t1.desc': 'rurki z piwnicy, na klatce okienko rewizyjne, do mieszkania rurką.',
  'weType.t2.label': 'Typ-2 (Komin)',
  'weType.t2.desc': 'kabel z mieszkania kominem szachtowym w dół do piwnicy.',
  'weType.t3.label': 'Typ-3 (Sufit)',
  'weType.t3.desc': 'zasilanie z mieszkania poniżej przez podłogę, dalej w górę przez sufit.',
  'weType.t4_r.label': 'Typ-4 (R-WE)',
  'weType.t4_r.desc': 'kanał od okienka rewizyjnego przez ścianę do mieszkania, bez przewiertu stropu.',
  'weType.t4_s.label': 'Typ-4 (S-WE)',
  'weType.t4_s.desc': 'kanał po klatce z przewiertem stropu na tej kondygnacji, przez ścianę do mieszkania.',
  'weType.f.label': 'F (Elewacja)',
  'weType.f.desc': 'kabel z zewnątrz przez ścianę zewnętrzną do mieszkania.',
  'weType.unknown': 'nieustalony',
  'weType.unknownDesc': 'typ mieszkania nieustalony (adres T5): wybierz typ przez „Zmień".',
  'weType.okKeep': 'OK, pozostaw {type}',
  'weType.changeQuestion': 'Zmienić typ z {from} na {to}?',
  'weType.changedToast': 'Typ WE zmieniony na {to}, sloty przebudowane',
  'weType.saveFailed': 'Nie udało się zapisać typu.',
  'weType.convertDialog': 'Adres przejdzie na nowe reguły (v2): stare sloty zostaną zmapowane, zdjęcia zachowane. Kontynuować?',
  'weType.v1Locked': 'Adres na starych regułach, zmianę typu robi Admin',
  'weType.readonly': 'Konto podglądowe nie może zmieniać typu mieszkania',
  'weType.ackBack': 'Rozumiem, wracam na {type}',
  'weType.previous': 'poprzedni typ',
  'lock.rules_v1_locked': 'Adres jest na starych regułach (montaż sprzed KW37). Nie możesz zmienić typu. Skontaktuj się z Martinem, on przełączy adres na nowe reguły.',
  'lock.t5_locked': 'Nie możesz zapisać tego typu. Skontaktuj się z Martinem, on włączy go dla Ciebie.',
  'lock.slot_automatic': 'To przebicie wynika z typu mieszkania (t3 na najniższej kondygnacji). Zniknie samo po zmianie typu WE, nie da się go usunąć ręcznie.',
  'lock.slot_has_photos': 'Ten slot ma już zdjęcia. Usunąć może go tylko Admin (skontaktuj się z Martinem).',
  'lock.bs_kd_required': 'BS-KD (główne przebicie) istnieje zawsze i nie da się go usunąć.',
  'lock.admin_cannot_configure': 'Konto podglądowe nie może zmieniać typu ani slotów.',
  'lock.forbidden': 'Ten adres jest przypisany do innego zespołu. Zadzwoń do Martina, on odblokuje adres.',
  'lock.invalid_fed_from': 'Wskazane mieszkanie zasilające nie istnieje piętro niżej. Wybierz inne z listy.',
  'lock.config_not_found': 'Adres nie ma jeszcze konfiguracji budynku. Najpierw zapisz wizard.',
  'lock.default': 'Nie udało się zapisać ({code}). Spróbuj ponownie albo skontaktuj się z Martinem.',
  'lock.errorWord': 'błąd',

  'addrType.T1.label': 'Typ-1 (Rurki)',
  'addrType.T1.desc': 'rurki z piwnicy, kabel przepychany na kolejne kondygnacje; na klatce okienko rewizyjne z rozgałęzieniem do mieszkań, w otworach rurek wata ognioodporna.',
  'addrType.T2.label': 'Typ-2 (Komin)',
  'addrType.T2.desc': 'z piwnicy przewiert do komina szachtowego (BS-KD); z każdego mieszkania kabel spuszczany kominem w dół, w każdym WE przebicie do komina; na piętrach nic.',
  'addrType.T3.label': 'Typ-3 (Sufit)',
  'addrType.T3.desc': 'przewiert z piwnicy prosto do mieszkania (BS-KD); dalej sufit WE → podłoga WE wyżej, pion przez mieszkania; na piętrach nic.',
  'addrType.T4.label': 'Typ-4 (Klatka)',
  'addrType.T4.desc': 'przewiert z piwnicy do klatki (BS-KD); kanały metalowe po klatce, przewiert stropu klatki na każdej kondygnacji, z klatki przez ścianę do WE.',
  'addrType.T5.label': 'Typ-5 (Mieszany)',
  'addrType.T5.desc': 'elewacja albo mieszanka (np. lewa część kominem, prawa klatką): każde WE konfigurowane osobno, F (elewacja) tylko per WE; możliwe kilka przebić z piwnicy (BS+).',

  'bs.bs_kd': 'BS-KD · przebicie z piwnicy (APL → budynek)',
  'bs.bs_rv': 'BS-RV · rewizja na klatce (wata w rurkach)',
  // MONIT 2026-10-02_1353 (pakiet v77) zad. 2: strzałka zaczyna się tam, gdzie stoi technik, i pokazuje, dokąd prowadzi przebicie.
  'bs.bs_th_b': 'BS-THb · Brandschutz klatka → piętro niżej (podłoga)',
  'bs.bs_th_d': 'BS-THd · Brandschutz klatka → piętro wyżej (sufit)',
  'bs.bs_we_w': 'BS-WEw · Brandschutz ściana mieszkania', // MONIT 2026-10-02_1112 (pakiet-etykiety-ikona-kafelki) zad. 2: wersja ogólna (typ WE nieustalony); per typ: bs.bs_we_w.<typ>
  'bs.bs_we_b': 'BS-WEb · Brandschutz mieszkanie → mieszkanie niżej (podłoga)',
  'bs.bs_we_d': 'BS-WEd · Brandschutz mieszkanie → mieszkanie wyżej (sufit)',
  'bs.kdOf': 'BS-KD ({n} z {total})',
  'slot.entfallen': 'Niepotrzebny dla tego adresu',
  'slot.entfallenKept': '{label} · zdjęcia zachowane ({n})',

  // ─── etykiety slotów (klucz = slot_key; warstwa wyświetlania) ────────────
  'slot.ta_offen': 'TA otwarte',
  'slot.ta_zu_qr': 'TA zamknięte i QR Code',
  'slot.ta_zu_qr_knd': 'QR Code mit Kabel',
  'slot.leitungsweg': 'Trasa kabla', // bez kontekstu (fallback); v79: wariant wg miejsca niżej (slotLabels.lswegLabel)
  // v79 (MONIT 2026-10-03_1200 zad. 2): trasa kabla wg miejsca (kontekst jak ikona: piętro KG / podfolder LsWeg / typ WE)
  'slot.leitungsweg.we': 'Trasa kabla w mieszkaniu do TA',
  'slot.leitungsweg.we.t4': 'Trasa kabla w mieszkaniu · ściana klatki → TA',
  'slot.leitungsweg.we.t1': 'Trasa kabla w mieszkaniu · rurka → TA',
  'slot.leitungsweg.we.t2': 'Trasa kabla w mieszkaniu · komin → TA',
  'slot.leitungsweg.we.t3': 'Trasa kabla w mieszkaniu · pion → TA',
  'slot.leitungsweg.we.f': 'Trasa kabla w mieszkaniu · okno → TA',
  'slot.leitungsweg.floor': 'Trasa kabla po klatce schodowej · {floor}',
  'slot.leitungsweg.kg': 'Trasa kabla w piwnicy · APL → przebicie w górę',
  'slot.ta_messung': 'Pomiar tłumienia',
  'slot.ta_name': 'Tabliczka / nazwisko',
  'slot.ta_zd': 'Ujęcie z daleka',
  'slot.brandschutz': 'Brandschutz (p.poż)',
  'slot.laser_test': 'Test lasera (czerwone światło)',
  'slot.lsweg_conn': 'Trasa kabla do tej części budynku: kanał, rura', // plan posesji B0 (MONIT 2026-10-03_1200 zad. 3): slot Połączenie, slot_key ostatecznie w B2
  'slot.knd_ablage': 'Miejsce pozostawienia kabla', // pakiet v78 (MONIT 2026-10-02_2226 zad. 2): 4. slot KND, tylko KND włączone po v78

  // ─── MusterGallery.jsx ────────────────────────────────────────────────────
  'muster.title': 'WZÓR ZDJĘCIA',
  'muster.must': '✓ NA ZDJĘCIU MUSI BYĆ',
  'muster.errs': '✗ CZĘSTE BŁĘDY',
  'muster.noEntry': 'Wzór dla tego slotu powstanie w kolejnej rundzie Muster.',
  'muster.closeAria': 'Zamknij wzór',
  'muster.imgAlt': 'Wzór: {name}',
  'muster.assetServer': '{key} (serwer)',
  'muster.assetLabel': 'asset: {asset}',
  'muster.source': 'źródło: zaakceptowane zdjęcie → rysunek',
  'muster.uploading': '⏳ Wgrywam…',
  'muster.replace': '🖼 Podmień grafikę (galeria) · ADMIN',
  'muster.footerTech': 'okno referencyjne, edycja wzorów tylko w trybie ADMIN',
  'muster.replaced': 'Grafika podmieniona ✓ (wersja v{version}), działa od razu, bez buildu.',
  'muster.replaceFailed': 'Nie udało się podmienić grafiki',

  // ─── configErrors.js (wizard) ─────────────────────────────────────────────
  'cfgErr.otherTeam': 'Ten adres jest przypisany do innego zespołu. To nie jest błąd aplikacji, tylko procedura: zadzwoń do Martina, on odblokuje adres.',
  'cfgErr.saveFailed': 'Nie udało się zapisać konfiguracji',
  'cfgErr.viewerCannot': 'Konto podglądowe nie może konfigurować budynku.',
  'cfgErr.teamCodeMissing': 'Team_Code nieuzupełniony w Airtable. Zgłoś do Martina.',
  'cfgErr.wouldDeleteSlots': 'Nie można zapisać: zmiana usunęłaby sloty z wgranymi zdjęciami. Zdjęć nie kasujemy. Zadzwoń do Martina.',
  'cfgErr.rulesV1Locked': 'Adres jest na starych regułach (montaż sprzed KW37). Nie możesz zmienić typu. Skontaktuj się z Martinem, on przełączy adres na nowe reguły i włączy typ dla Ciebie.',
  'cfgErr.t5Locked': 'Nie możesz zapisać tego typu. Skontaktuj się z Martinem, on włączy go dla Ciebie.',
  'cfgErr.resetFailed': 'Nie udało się wyczyścić',
  'cfgErr.resetForbidden': 'Tylko technik lub admin może wyczyścić. Sprawdź uprawnienia.',
  'cfgErr.resetReason': 'Podaj krótki powód resetu (min 3 znaki).',
  'cfgErr.blockedN': 'Zapis zablokowany: zmiana usunęłaby {n} zdjęć w slotach: {lista}.',
  'cfgErr.cannotSaveN': 'Nie można zapisać: zmiana usunęłaby {n} zdjęć w slotach: {lista}. Zdjęć nie kasujemy. Jeśli konfiguracja naprawdę musi się zmienić, zadzwoń do Martina.',

  // ─── erklaerungErrors.js (dokument zgody) ────────────────────────────────
  'erkErr.GRUENDE_MISSING': 'Zaznacz przynajmniej jeden powód odstępstwa (Grund der abweichenden Montage).',
  'erkErr.GRUND_UNKNOWN': 'Nieznany powód odstępstwa. Odśwież aplikację i spróbuj ponownie.',
  'erkErr.GRUND_ANDERER_TEXT_MISSING': 'Pozycja „Anderer Grund" wymaga krótkiego opisu.',
  'erkErr.GRUND_ANDERER_TEXT_TOO_LONG': 'Opis „Anderer Grund" jest za długi: maksymalnie 90 znaków, jedna linia.',
  'erkErr.POSITION_TOO_LONG': 'Opis pozycji montażu jest za długi: maksymalnie 160 znaków (2 linie).',
  'erkErr.MISSING_VORNAME': 'Podaj imię klienta.',
  'erkErr.SIGNATURE_MISSING': 'Brakuje podpisu. Poproś klienta o podpis w ramce.',
  'erkErr.SIGNATURE_EMPTY': 'Podpis jest pusty lub zbyt słaby. Poproś klienta o ponowny podpis.',
  'erkErr.SIGNATURE_TOO_SMALL': 'Podpis jest za mały. Poproś klienta o zamaszysty podpis przez całą ramkę.',
  'erkErr.SIGNATURE_BAD': 'Podpis nie zapisał się poprawnie. Wyczyść ramkę i spróbuj ponownie.',
  'erkErr.SIGNATURE_TOO_BIG': 'Podpis jest za duży. Wyczyść ramkę i podpisz ponownie.',
  'erkErr.address_missing_kw': 'Adres nie ma Ausbau Termin w Airtable. Zgłoś do biura, dokument poczeka.',
  'erkErr.address_missing_street': 'Adres nie ma ulicy/numeru w Airtable. Zgłoś do biura.',
  'erkErr.address_missing_team': 'Adres nie ma przypisanego zespołu. Zgłoś do biura, dokument poczeka.',
  'erkErr.address_not_found': 'Nie znaleziono adresu. Odśwież listę zadań.',
  'erkErr.airtable_error': 'Airtable chwilowo nie odpowiada. Spróbuj ponownie za chwilę.',
  'erkErr.admin_cannot_sign': 'Konto podglądowe nie może wystawiać dokumentów. Dokument podpisuje klient przy techniku.',
  'erkErr.forbidden': 'Ten adres należy do innego zespołu.',
  'erkErr.sidecar_unreachable': 'Generator dokumentu jest niedostępny. Spróbuj ponownie za 1-2 minuty.',
  'erkErr.sidecar_bad_payload': 'Generator zwrócił uszkodzony dokument. Spróbuj ponownie, a jeśli się powtórzy, zgłoś do biura.',
  'erkErr.storage_error': 'Nie udało się zapisać pliku na serwerze. Spróbuj ponownie.',
  'erkErr.db_error': 'Błąd bazy danych. Spróbuj ponownie.',
  'erkErr.db_insert_failed': 'Błąd zapisu do bazy: dokument NIE został zapisany, spróbuj ponownie.',
  'erkErr.offline': 'Dokument zgody wymaga połączenia z internetem: PDF generuje serwer, a klient podpisuje od razu. Wróć do zasięgu (np. przed budynek) i spróbuj ponownie.',
  'erkErr.generateFailed': 'Nie udało się wygenerować dokumentu{status}. Spróbuj ponownie.',

  // ─── drobne helpery ───────────────────────────────────────────────────────
  'photo.rejectedDefault': 'odrzucone ręcznie przez biuro',
  'upload.notSentNof': 'Nie wysłano {failed} z {total}: {names}',
  'settings.noLimit': 'bez ograniczeń',
  'settings.kw': '{v} KW',
  'settings.backForward': '{back} wstecz · {forward} naprzód',
  'settings.on': 'włączony',
  'settings.offUpper': 'WYŁĄCZONY',
  'weeks.pick': 'Wybierz tydzień',
  'weeks.pickKw': 'Wybierz KW',
  'weeks.nWeeks': '{n} tygodni',
  'queue.local': '🔒 Tryb lokalny · {total} {photos} na telefonie',
  'queue.failedN': { one: 'nieudane', few: 'nieudane', many: 'nieudanych' },
  'queue.failedSuffix': ' ({failed} {word})',
  'ago.s': '{n} s temu',
  'ago.min': '{n} min temu',
  'ago.h': '{n} godz. temu',
  'ago.d': '{n} dni temu',
  'settings.until': 'do {ts}',
  'settings.indefinite': 'bezterminowo',
  'erkErr.MISSING_NACHNAME': 'Podaj nazwisko klienta.',
  'upload.noName': 'bez nazwy',
  'cfg.photosAbbr': '{n} zdj.',

  // ─── TaskListScreen.jsx ───
  'tasks.status.empty': 'Do zrobienia',
  'tasks.status.active': 'W PWA 🟢',
  'tasks.status.blocked': 'Zablokowany 🔒',
  'tasks.status.completed': 'Zakończony ✅',
  'tasks.continue': 'Kontynuuj',
  'tasks.start': 'Rozpocznij',
  'tasks.blockedBadge': 'Zablokowany',
  'tasks.adminBtn': '🔧 Admin',
  'tasks.pending': 'Oczekujące',
  'tabs.tasks': 'Zadania',
  'tabs.map': 'Mapa',
  'tabs.settings': 'Ustawienia',
  'tasks.plannedInstall': 'Planowany montaż',
  'tasks.mapSoon': 'Mapa: wkrótce 🗺️',
  'tasks.queueChipTitle': '{n} zdj. czeka na wysyłkę',
  'tasks.serwisThisPhone': 'Serwis: ten telefon',
  'auth.logout': 'Wyloguj',
  'tasks.offlineList': '⚠ Offline: pokazuję ostatnią listę z telefonu',
  'tasks.staleWeek': '📅 KW {kw}: nieaktualny tydzień',
  'tasks.currentWeekBtn': '→ Bieżący tydzień',
  'tasks.loading': 'Ładowanie zadań…',
  'tasks.refreshing': '⟳ Odświeżam…',
  'tasks.noAddresses': 'Brak adresów w tym tygodniu dla teamu {team}.',
  'tasks.checkOtherWeeks': 'Sprawdź inne tygodnie przyciskiem poniżej.',
  'tasks.otherWeeks': 'Inne tygodnie',
  'tasks.billing': '💶 Rozliczenia',
  'tasks.billingSoon': 'Rozliczenia: moduł w przygotowaniu 💶',
  'settings.title': 'USTAWIENIA',
  'settings.theme': 'Motyw',
  'settings.language': 'Język / Sprache',

  // ─── LoginScreen.jsx ───
  'login.adminPrompt': 'Podaj PIN administratora',
  'login.teamPrompt': 'Podaj PIN teamu',
  'login.dbUnavailable': 'Baza niedostępna, spróbuj za minutę',
  'login.invalidPin': 'Nieprawidłowy PIN',
  'login.clearAria': 'Wyczyść',
  'login.backspaceAria': 'Cofnij',
  'login.loggingIn': 'Logowanie…',
  'login.submit': 'Zaloguj',
  'login.logoTitle': '5× tap (lub long-press 3s) = pole kodu',
  'login.admin': 'Admin',

  // ─── AdminTaskListScreen.jsx ───
  'months.short': 'sty,lut,mar,kwi,maj,cze,lip,sie,wrz,paź,lis,gru',
  'admin.administrator': 'Administrator',
  'admin.windowBadge': 'okno: {v}',
  'admin.allKw': 'wszystkie KW',
  'admin.serwisTitle': 'Panel Serwis: ustawienia systemowe',
  'admin.serwis': '🛠 Serwis',
  'admin.allAssignedTeams': 'Wszystkie przypisane teamy',
  'admin.allTeams': 'Wszystkie teamy',
  'admin.loadingTeams': 'Ładowanie teamów…',
  'admin.pickTeam': 'Wybierz team…',
  'admin.teamAria': 'Wybór teamu',
  'admin.allProjects': 'Wszystkie projekty',
  'admin.pickProject': 'Wybierz projekt…',
  'admin.projectAria': 'Wybór projektu',
  'admin.kwUnsetSub': 'tydzień nieustalony, planowanie',
  'admin.currentWeek': '(bieżący)',
  'admin.pickWeek': 'Wybierz tydzień…',
  'admin.weekAria': 'Wybór tygodnia',
  'admin.resetFiltersTitle': 'Wyczyść filtry: wróć do aktualnego KW + wszystkich teamów',
  'admin.resetFilters': 'Wyczyść filtry',
  'admin.summary': 'Podsumowanie',
  'admin.allTeamsLower': 'wszystkie teamy',
  'admin.projectWord': 'projekt',
  'admin.inProgress': 'W toku',
  'admin.perTeam': 'Per team (WE · TA · Vorb. · w toku)',
  'admin.pickKwToSee': 'Wybierz KW, aby zobaczyć adresy',
  'admin.noAddressesIn': 'Brak adresów w {range}{team}.',
  'admin.forTeam': ' dla teamu {team}',
  'admin.syncBar': '☁ Sync OneDrive: {state}{queue}',
  'admin.syncCopying': 'kopiowanie {copied}{total}',
  'admin.syncIdle': 'bezczynny',
  'admin.syncQueued': ' · w kolejce: {n}',
  'admin.testAi': '🤖 Test AI',
  'admin.inQueue': '⏳ W kolejce{pos}',
  'admin.syncChangesTitle': 'Są nowe zmiany od ostatniego sync. Klik aby wgrać do OneDrive.',
  'admin.syncChanges': '🔄 Sync zmiany',
  'admin.openOneDrive': '🔗 Otwórz w OneDrive',
  'admin.oneDrive': '📤 OneDrive',
  'admin.resetTitle': 'Reset AI verdicts + nazwy plików (zdjęcia zostają, kafelki wracają na zielone)',
  'admin.resetting': '🔄 Resetuję…',
  'admin.resetBtn': '🔄 Reset AI state',
  'admin.resetConfirm': 'Zresetować AI dla adresu "{address}"?\n\n• Zdjęcia zostają (nic NIE jest kasowane)\n• Verdict (ok/Fail/Err) → wyczyszczony\n• Kod OXG (gniazdka QR) → wyczyszczony\n• Nazwy plików: sufiks _ok/_Fail/_Err znika, TA_QR-Code wraca do TA_zu_QR\n• Kafelki wrócą na zielone, możesz odpalić Test AI ponownie\n• Pliki w OneDrive zostaną zaktualizowane (stare nazwy usunięte, nowe wgrane)\n\nKontynuować?',
  'admin.resetOk': '🔄 Reset OK: {photos} zdjęć, {renamed} rename, {archived} archived (_v(N)) · {s}s',
  'admin.retry': '↻ Ponów',
  'admin.weeksLoadFailed': 'Nie udało się pobrać listy tygodni',
  'admin.teamsLoadFailed': 'Nie udało się pobrać listy teamów',
  'admin.addressesLoadFailed': 'Błąd ładowania adresów',
  'admin.lastKw': ' · ostatnio: KW{kw}',
  'admin.noTerminsSince': ' · brak terminów od 12 tyg.',
  'admin.unassigned': 'nieprzypisany',

  // ─── AddressDetailScreen.jsx ───
  'addr.loadFailed': 'Nie udało się pobrać danych',
  'addr.fallbackName': 'Adres',
  'addr.kndBadge': '{n}× KND',
  'addr.slotsCount': '· {n} slotów',
  'addr.deviationsTitle': 'Odstępstwa: {list}',
  'addr.mischbauTitle': 'Adres mieszany (Typ-5)',
  'addr.keller': 'Keller',
  'addr.kellerSub': '(Piwnica)',
  'addr.bsSub': '(BS zbiorczy, Typ-5)',
  'addr.egSub': '(Parter)',
  'addr.ogSub': '(Piętro)',
  'addr.info': 'Info',
  'addr.noFloors': 'Brak pięter w konfiguracji.',
  'addr.config': '⚙️ Konfiguracja',
  'addr.openOneDrive': 'Otwórz folder w OneDrive',

  // ─── FloorWEListScreen.jsx ───
  'floor.bsKdSub': 'przebicie główne (bez piwnicy)',
  'group.gebaeudeSub': 'Budynek z daleka + Domofon',
  'group.aplSub': 'Abschlusspunkt Linie (bez piwnicy)',
  'group.gvSub': 'Rozdzielacz (bez piwnicy)',
  'group.spEgSub': 'Sammelpunkt (bez piwnicy)',
  'group.weSub': 'Mieszkanie',
  'group.lswegSub': 'Trasa kabla po klatce schodowej', // v79: kafelek LsWeg na ekranie piętra
  'group.lswegSubKg': 'Trasa kabla w piwnicy', // v79: kafelek LsWeg na ekranie piwnicy
  'group.bsSub': 'Brandschutz',
  'group.spSub': 'Sammelpunkt',
  'floor.noConfig': 'Brak konfiguracji. Przejdź przez wizard.',
  'floor.slotsLoadFailed': 'Błąd pobierania slotów',
  'floor.resetConfirm': 'Zresetować AI dla piętra {floor}?\n\n• Zdjęcia tego piętra zostają (NIE są kasowane)\n• Verdict (ok/Fail/Err) → wyczyszczony\n• Nazwy plików: sufiks _ok/_Fail/_Err znika, TA_QR-Code wraca do TA_zu_QR\n• Sloty piętra wrócą na zielone, możesz odpalić Sprawdź AI ponownie\n• ⏱ Operacja może potrwać kilka minut\n\nKontynuować?',
  'floor.resetTimeout': 'Timeout po 15 min, operacja może być kontynuowana na backendzie. Odśwież ekran.',
  'floor.title': 'Piętro',
  'floor.noSlots': 'Brak slotów na {floor}.',
  'floor.kndHist': 'historia KND · {n} zdj.',
  'floor.kndHistProof': 'dowód wizyty (archiwum)',
  'floor.checkAi': '🤖 Sprawdź AI ({floor})',
  'floor.resetTitle': 'Reset AI state dla piętra (zdjęcia zostają, verdicts czyszczone)',
  'floor.resetting': '🔄 Resetuję piętro…',
  'floor.resetBtn': '🔄 Reset AI piętra ({floor})',
  'floor.resetLong': '⏱ Reset trwa do 10 min, nie zamykaj okna.',
  'floor.resetOk': '🔄 Reset OK: {photos} zdjęć, {renamed} rename · {s}s',

  // ─── małe komponenty UI (WeCountersBar, AppErrorBoundary, GalleryModeToggle, LongPressTrash, ThemeToggleButton) ───
  'weCounters.wePlanned': 'TA razem',
  'weCounters.wePlannedTitle': 'WE zaplanowane na tym adresie',
  'weCounters.taMounted': 'zamont.',
  'weCounters.taMountedTitle': 'TA zamontowane: WE z kompletem slotów',
  'weCounters.vorbereitung': 'Vorb.',
  'weCounters.vorbereitungTitle': 'Vorbereitung: WE typu KND z kompletem',
  'weCounters.wInProgress': 'w toku',
  'weCounters.wInProgressTitle': 'W toku: rozpoczęte, jeszcze niekompletne',
  'errb.unknown': 'nieznany błąd',
  'errb.title': 'Aplikacja napotkała błąd',
  'errb.body': 'Zdjęcia w kolejce są bezpieczne w pamięci telefonu. Przeładuj aplikację; jeśli błąd wraca, wyślij diagnostykę.',
  'errb.reload': 'Przeładuj',
  'errb.sent': '✓ Diagnostyka dotarła do centrali',
  'errb.queued': '✓ Diagnostyka zapisana (wyśle się przy zasięgu)',
  'errb.send': 'Wyślij diagnostykę do centrali',
  'galleryMode.ariaGallery': 'Tryb: galeria (przełącz na aparat)',
  'galleryMode.ariaCamera': 'Tryb: aparat (przełącz na galerię)',
  'galleryMode.titleGallery': 'Tryb galerii, kliknij by wrócić do aparatu',
  'galleryMode.titleCamera': 'Tryb aparatu, kliknij by używać galerii telefonu',
  'trash.confirm': 'Czy na pewno usunąć?',
  'trash.title': 'Przytrzymaj 3s by usunąć',
  'trash.aria': 'Usuń (przytrzymaj 3s)',

  // --- KellerViewScreen.jsx + SPSlotsScreen.jsx ---
  'keller.title': 'Piwnica',
  'keller.aplSub': 'Punkt dostępowy',
  'keller.aplnSub': 'Abschlusspunkt Linie',
  'keller.gvSub': 'Rozdzielacz',
  'keller.noSlots': 'Brak slotów w Kellerze dla tego typu instalacji.',
  'keller.checkAi': '🤖 Sprawdź AI (Keller)',
  'slots.photosHeader': 'Zdjęcia · {sub}',
  'sp.idLabel': 'Identyfikacja SP',
  'sp.spleissLabel': 'Spaw (min {min}, max 6)',
  'sp.photosHere': 'Zdjęć w tym SP: {n}',
  'photo.deleteFailed': 'Nie udało się usunąć zdjęcia',
  'photo.addFailed': 'Nie udało się dodać zdjęcia',

  // --- GVSlotsScreen.jsx ---
  'gv.idName': 'Identyfikacja (nalepka)',
  'gv.offen': 'GV otwarty (wnętrze)',
  'gv.spleiss': 'Tacka spawów (min {min})',
  'apl.offen': 'APL otwarty (wnętrze)',
  'apl.id': 'APL: identyfikacja',
  'bs.minLabel': 'Brandschutz (min {min})',
  'spg.id': 'SP: identyfikacja',
  'spg.spleiss': 'Spawy (min {min})',
  'slot.generic': 'Zdjęcie',
  'gv.title': 'Rozdzielacz {sub}',
  'apl.title': 'Punkt {sub}',
  'bs.minusConfirm': 'BS{n}-KD ma {photos} zdj. Usunąć to przebicie razem ze zdjęciami? (wymuszenie Admina, nieodwracalne)',
  'bs.minusAdminOnly': 'BS- · tylko Admin ({photos} zdj.)',
  'bs.minusRemove': 'BS- · usuń BS{n}-KD',
  'bs.plus': 'BS+ · dodaj kolejne przebicie z piwnicy',
  'lock.title': 'Blokada',
  'gv.photosHere': 'Zdjęć w {sub}: {n}',

  // --- FloorSubfolderScreen.jsx ---
  'sub.bsLabel': 'Brandschutz (uszczelnienie)',
  'sub.gebaeudeFern': 'Budynek z daleka',
  'sub.domofon': 'Domofon',
  'sub.lswegTitle': 'Trasa kabla (LsWeg)', // przycisk „Sprawdź AI (…)” na ekranie LsWeg piętra (bez zmian)
  'sub.lswegTitleFloor': 'Trasa kabla po klatce schodowej (LsWeg)', // v79: tytuł podwidoku (piętro w nadtytule)
  'sub.lswegTitleKg': 'Trasa kabla w piwnicy (LsWeg)', // v79: tytuł podwidoku piwnicy
  'sub.unknown': 'Nieznany subfolder: {sub}',

  // --- PhotoTaskListScreen.jsx (ekran slotów WE) ---
  'we.photosLoadFailed': 'Nie udało się pobrać zdjęć',
  'we.cfgMissingWizard': 'Brak konfiguracji budynku. Przejdź przez wizard konfiguracji.',
  'we.cfgMissing': 'Brak danych konfiguracji adresu.',
  'we.syncInProgress': 'Wysyłka w toku ({done} z {total}), poczekaj',
  'we.noConnectionAuto': 'Brak połączenia. Wysyłka ruszy sama po powrocie zasięgu.',
  'we.retrying': 'Ponawiam wysyłkę ({n} zdj.)…',
  'we.resetConfirm': 'Zresetować AI dla {floor}/{we}?\n\n• Zdjęcia tego WE zostają (NIE są kasowane)\n• Verdict (ok/Fail/Err) → wyczyszczony\n• Nazwy plików: sufiks _ok/_Fail/_Err znika\n• Sloty WE wrócą na zielone, możesz odpalić Sprawdź AI ponownie\n• ⏱ Operacja może potrwać kilka minut\n\nKontynuować?',
  'we.kndConfirm': 'Oznaczyć {we} jako "Kunde nicht da" (klient nieobecny)?\n\n• Wystarczą 3 zdjęcia: tabliczka z nazwiskiem, naklejka QR-kod, test lasera\n• Pozostałe sloty WE zostaną UKRYTE\n• Można cofnąć (długie przytrzymanie button KND) gdy klient się pojawi\n\nKontynuować?',
  'we.kndEnableFailed': 'Nie udało się włączyć KND',
  'we.reloConfirmOn': 'TA montowane w innym miejscu niż procedura (na życzenie klienta, za zgodą właściciela)?\n\n• slot „Ujęcie z daleka” przełączy się w tryb rozszerzony\n• pojawi się przycisk dokumentu zgody do podpisu',
  'we.reloConfirmOffSigned': 'Wyłączyć tryb przeniesienia TA?\n\nSlot dokumentu zostanie ukryty, ale podpisany dokument ZOSTAJE w dokumentacji (biuro nadal go widzi).',
  'we.reloConfirmOff': 'Wyłączyć tryb przeniesienia TA?',
  'we.docSavedToast': '📄 Dokument zgody zapisany: PDF na półce WE, kopia leci do teczki AKP\'s',
  'we.kndDisableFailed': 'Nie udało się wyłączyć KND',
  'we.slotNotCreated': 'Slot jeszcze nie utworzony. Wgraj jedno zdjęcie, potem cofnij.',
  'we.deactivateConfirm': 'Brak trasy kabla w tym mieszkaniu?\n\nSlot "{label}" zostanie deaktywowany, nie liczy się do progresu. Wymaganych slotów spadnie z {from} na {to}.\n\nMożesz cofnąć (przycisk "↩ Aktywuj") jeśli się rozmyślisz.',
  'we.deactivateFailed': 'Nie udało się dezaktywować slotu',
  'we.reactivateFailed': 'Nie udało się aktywować slotu',
  'we.doneCount': '{done}/{total} wykonanych',
  'we.kndActive': '🚪 KND aktywne',
  'we.since': 'od {date}',
  'we.kndArchiveInfo': '🚪 Archiwum KND: dowód wizyty (tylko podgląd). Zdjęcia liczą się do dokumentacji i OneDrive; nowe podłączenie robisz w normalnym kafelku WE.',
  'we.residentAbsent': 'Brak mieszkańca',
  'we.residentPresent': 'Mieszkaniec obecny',
  'we.kndAriaAbsent': 'Brak mieszkańca. Przełącz, gdy klient się pojawił',
  'we.kndAriaPresent': 'Mieszkaniec obecny. Przełącz na Kunde nicht da',
  'we.kndTitleAbsent': 'Klient się pojawił? Przełącz, by wyłączyć KND (wymagany powód)',
  'we.kndTitlePresent': 'Klient nieobecny? Przełącz na KND, wystarczą 3 zdjęcia dowodu',
  'we.docAdminNote': '📄 Dokument zgody (podpisany: {kunde}), tryb relo wyłączony przez technika, dokument zostaje',
  'we.noLocalData': 'Brak danych lokalnych dla tego adresu.',
  'we.tryAgain': '↻ Spróbuj ponownie',
  'we.slotDeactivated': 'Slot deaktywowany, nie liczy się do progresu',
  'we.activate': '↩ Aktywuj',
  'we.noRouteTitle': 'Brak trasy kabla w tym mieszkaniu, slot zostanie deaktywowany (nie liczy się do progresu)',
  'we.deactivating': '🔄 Deaktywuję…',
  'we.noRouteHere': '❌ Tutaj nie ma trasy',
  'we.uploadTitle': 'Wysyłka zdjęć',
  'we.sendingLong': 'Wysyłam {done} z {total} zdj., poczekaj. W kolejce tego mieszkania: {n} ({slots}).',
  'we.notSentLong': 'Nie wysłano: {n} zdj. ({slots}). Tap w „Ponów" uruchamia wysyłkę od razu; bez zasięgu ruszy sama po jego powrocie.',
  'we.sendingShort': '⏳ Wysyłam… ({done} z {total})',
  'we.notSentShort': '⚠ Nie wysłano: {n} zdj. ({slots})',
  'we.sending': 'Wysyłam…',
  'we.aiRunning': '🤖 Komplet! AI sprawdza automatycznie…',
  'we.aiDone': '🤖 AI: sprawdzone ✓ (start automatyczny)',
  'we.aiIdle': '🤖 AI wystartuje samo przy komplecie',
  'we.inPwa': 'W PWA: {n} zdjęć',
  'we.kndDisableTitle': '↩ Wyłączyć KND dla {we}?',
  'we.kndDisableIntro': 'Klient się pojawił → Nachmontage. Po wyłączeniu:',
  'we.kndLi1Pre': 'WE wraca do ',
  'we.kndLi1Strong': '6 standardowych slotów',
  'we.kndLi2Pre': 'Slot ',
  'we.kndLi2Post': ' deaktywowany (zdjęcia jeśli były → historic)',
  'we.kndLi3Pre': 'Slot ta_name (nazwisko) i ta_zu_qr (QR): zaakceptowane zdjęcia ',
  'we.kndLi3Strong': 'zostają',
  'we.reasonLabel': 'Powód wyłączenia (audit) ',
  'we.reasonPlaceholder': 'np. klient wrócił, Nachmontage, pomyłka',
  'we.reasonHint': 'ⓘ Wpisz powód (min 3 znaki)',
  'we.reasonCount': ', masz {n}/3',
  'we.reasonTitle': 'Wpisz powód (min 3 znaki)',
  'we.disableKndTitle': 'Wyłącz KND',
  'we.disabling': '🔄 Wyłączam…',
  'we.disableKnd': '↩ Wyłącz KND',
  'we.resetTitle': 'Reset AI state dla {we} (zdjęcia zostają, verdicts czyszczone)',
  'we.resetting': '🔄 Resetuję WE…',
  'we.resetBtn': '🔄 Reset AI ({we})',

  // --- SlotButton.jsx ---
  'slotBtn.queuedName': 'czeka na wysyłkę',
  'slotBtn.emptyCamera': 'Puste zdjęcie z aparatu. Zrób je jeszcze raz',
  'slotBtn.saveLocalFailed': 'Nie udało się zapisać zdjęcia na telefonie',
  'slotBtn.noFolders': 'Wrzucaj pojedyncze pliki, nie foldery',
  'slotBtn.notImages': 'Wrzucone elementy nie są obrazami (image/*)',
  'slotBtn.qUploading': 'Wysyłanie…',
  'slotBtn.qFailed': 'Nie wysłano (5 prób), użyj „Wyślij teraz"',
  'slotBtn.qWaiting': 'Czeka na wysyłkę',
  'slotBtn.thumbQueuedAria': 'Zdjęcie {n}: czeka na wysyłkę',
  'slotBtn.thumbAria': 'Zobacz zdjęcie {n}',
  'slotBtn.openDocAria': 'Otwórz dokument zgody',
  'slotBtn.docTitle': 'Dokument zgody (przeniesienie TA)',
  'slotBtn.moreAria': '{n} zdjęć łącznie, pozostałe w galerii',
  'slotBtn.musterAria': 'Zobacz wzór zdjęcia',
  'slotBtn.musterTitle': 'Zobacz jak powinno wyglądać to zdjęcie',
  'slotBtn.musterCaption': 'wzór',
  'slotBtn.aiVerified': 'Zweryfikowane AI',
  'slotBtn.aiProblem': 'AI znalazło problem',
  'slotBtn.aiError': 'Błąd sprawdzenia AI',
  'slotBtn.showReason': 'Pokaż powód odrzucenia',
  'slotBtn.rejectedBgAria': 'Zdjęcie odrzucone w tle, pokaż powód',
  'slotBtn.rejectionLine': '⛔ {reason}{file}. Zrób nowe zdjęcie.',
  'slotBtn.reloOn': 'TA przeniesione za zgodą{check}',
  'slotBtn.reloAsk': 'TA w innym miejscu?',
  'slotBtn.galleryAria': 'Wybierz z galerii telefonu',
  'slotBtn.cameraAria': 'Zrób zdjęcie (przytrzymaj 1s dla galerii telefonu)',
  'slotBtn.galleryTitle': 'Tryb galerii: wybierz gotowe zdjęcie z telefonu.',
  'slotBtn.cameraTitle': 'Kliknij = aparat. Przytrzymaj 1s = galeria telefonu.',
  'slotBtn.docBtn': '📄 Dokument zgody: podpis klienta{check}',
  'slotBtn.docNote': 'TA przeniesione za zgodą właściciela · dokument dołączy do dokumentacji',

  // --- PhotoGallery.jsx (lightbox) ---
  'gal.err.gemini_timeout': 'Gemini przekroczył limit czasu',
  'gal.err.gemini_rate_limit': 'Gemini rate limit (429). Spróbuj za chwilę',
  'gal.err.gemini_5xx': 'Gemini server error (5xx)',
  'gal.err.gemini_parse_error': 'Gemini zwrócił niepoprawny JSON',
  'gal.err.gemini_not_configured': 'Gemini API key nieskonfigurowane',
  'gal.err.gemini_unknown': 'Nieznany błąd Gemini',
  'gal.err.network': 'Błąd sieci / brak połączenia z API',
  'gal.err.photo_without_slot': 'Zdjęcie bez slotu, AI nie ma czego ocenić. Zgłoś do Martina.',
  'gal.err.recheck': 'Błąd recheck',
  'gal.cancelSelect': 'Anuluj wybór',
  'gal.deselect': 'Odznacz to zdjęcie',
  'gal.selectForDelete': 'Zaznacz to zdjęcie do usunięcia',
  'gal.queuedNoTrash': 'Zdjęcie czeka na wysyłkę, kosz po synchronizacji',
  'gal.spaceHint': 'Spacja = zaznacz/odznacz bieżące zdjęcie',
  'gal.thisPhoto': 'To zdjęcie',
  'gal.deleting': 'Usuwam…',
  'gal.deleteN': 'Usuń ({n})',
  'gal.emptySkipped': 'Pusty plik pominięty: {name}',
  'gal.addFromGalleryAria': 'Dodaj z galerii telefonu',
  'gal.addFromGalleryTitle': 'Dodaj zdjęcie z galerii telefonu',
  'gal.trashAria': 'Usuń zdjęcia (wybór)',
  'gal.trashTitle': 'Kliknij, aby wybrać zdjęcia do usunięcia',
  'gal.photoAlt': 'Zdjęcie',
  'gal.prev': 'Poprzednie zdjęcie',
  'gal.next': 'Następne zdjęcie',
  'gal.queuedStrong': 'Czeka na wysyłkę',
  'gal.queuedUploading': ' (wysyłanie…)',
  'gal.queuedFailed': ' (nieudane, użyj „Wyślij teraz")',
  'gal.queuedRest': '. Zdjęcie jest na telefonie; ocena AI i kosz po synchronizacji.',
  'gal.closeError': 'Zamknij komunikat błędu',
  'gal.rejectedByOffice': 'Odrzucone ręcznie przez biuro',
  'gal.office': 'Biuro:',
  'gal.aiErrorAria': 'Błąd AI',
  'gal.aiErr': 'Błąd sprawdzenia{reason}. Spróbuj „Sprawdź ponownie".',
  'gal.acptAria': 'Zaakceptowane ręcznie',
  'gal.acptStrong': 'Ręczna akceptacja',
  'gal.acptRest': ', pierwotnie Fail/Err z AI',
  'gal.rejectTitle': 'Cofnij akceptację: zdjęcie wraca na czerwono do poprawki',
  'gal.reject': '⛔ Odrzuć',
  'gal.acceptManual': '✅ Akceptuj ręcznie',
  'gal.noDetails': 'Brak szczegółów błędu',
  'gal.orphanMsg': 'Zdjęcie nie jest przypięte do żadnego slotu',
  'gal.noConnection': 'Brak połączenia',
  'gal.recheckTitle': 'Wyślij to zdjęcie ponownie do Gemini (np. po err timeout)',
  'gal.rechecking': '🔄 Sprawdzam…',
  'gal.recheck': '🔄 Sprawdź ponownie',
  'gal.acceptAllConfirm': 'Zaakceptować {n} z {total} zdjęć w slocie?\n\nWszystkie nieakceptowane zdjęcia dostaną verdict=\'acpt\' (manual override) + sufix _Acpt w nazwie pliku. OneDrive sync dostanie zaktualizowane filename.',
  'gal.bulkError': 'Błąd bulk-override',
  // Pakiet v81 (MONIT 2026-10-04_0101 zad. 2): odmiana liczebnika (1 zdjęcie / 2-4 zdjęcia / 5+ zdjęć).
  'gal.acceptAllTitle': { one: 'Zaakceptuj 1 zdjęcie w tym slocie (admin bulk-override)', few: 'Zaakceptuj wszystkie {n} zdjęcia w tym slocie naraz (admin bulk-override)', many: 'Zaakceptuj wszystkie {n} zdjęć w tym slocie naraz (admin bulk-override)' },
  'gal.acceptingAll': '✓ Akceptuję wszystkie…',
  'gal.acceptAll': { one: '✓ Akceptuj cały slot (1 zdjęcie)', few: '✓ Akceptuj cały slot ({n} zdjęcia)', many: '✓ Akceptuj cały slot ({n} zdjęć)' },
  'gal.overrideTitle': '✅ Zaakceptuj zdjęcie ręcznie',
  'gal.aiRejected': 'AI odrzuciło to zdjęcie:',
  'gal.reasonSheetTitle': 'Powód odrzucenia AI',
  'gal.noReason': 'brak powodu',
  'gal.ovPre': 'Po kliknięciu ',
  'gal.ovAccept': 'Akceptuj',
  'gal.ovMid': ': verdict zmieni się na ',
  'gal.ovMid2': ', plik zostanie zrenamowany ',
  'gal.ovPost': ', zapiszemy audit (kto, kiedy, dlaczego).',
  'gal.reasonOptional': 'Powód (opcjonalny, max 500 znaków):',
  'gal.reasonPlaceholder': 'np. Gemini za rygorystyczny, zdjęcie OK',
  'gal.overrideError': 'Błąd override',
  'gal.accepting': 'Akceptuję…',
  'gal.accept': '✅ Akceptuj',
  'gal.rejectModalTitle': '⛔ Odrzuć zaakceptowane zdjęcie',
  'gal.rjReject': 'Odrzuć',
  'gal.rjMid': ': werdykt wraca na czerwono (',
  'gal.rjPost': ' w nazwie pliku), slot i adres robią się czerwone, technik zobaczy powód i ma dograć zdjęcie. Zapisujemy audyt (kto, kiedy, powód). Zdjęcie NIE jest kasowane.',
  'gal.reasonForTech': 'Powód dla technika (opcjonalny, max 500 znaków):',
  'gal.rejectPlaceholder': 'puste = „odrzucone ręcznie przez biuro”',
  'gal.rejectError': 'Błąd odrzucania',
  'gal.rejecting': 'Odrzucam…',

  // --- UploadErrorToast + ForceUploadButton + AiCheckButton ---
  'upToast.serverErr': 'Błąd serwera (HTTP {status})',
  'upToast.connErr': 'Błąd połączenia',
  'upToast.httpErr': 'Błąd HTTP {status}',
  'upToast.notSent': '⚠ Zdjęcie nie zostało wysłane: {label}',
  'upToast.retry': '🔄 Spróbuj ponownie',
  'force.idle': '📤 Wyślij teraz',
  'force.pressing': '⏳ Wysyłanie…',
  'force.done': '✓ Wysłane',
  'force.partial': '⚠ nie wysłano ({n})',
  'force.title': 'Wymuś wysłanie zdjęć z kolejki (gdy Android Chrome opóźnia automatyczny sync)',
  'ai.afterSyncToast': 'Sprawdzenie AI ruszy po synchronizacji: {n} zdj. czeka na wysyłkę.',
  'ai.unknownError': 'Nieznany błąd AI check',
  'ai.running': '🤖 Sprawdzam zdjęcia AI… (do 60s)',
  'ai.afterSync': '{label}: po synchronizacji ({n} czeka)',
  'ai.check': '🤖 Sprawdź AI',
  'ai.errorTitle': '⚠ Błąd sprawdzenia AI',
  'ai.resultTitle': '🤖 Wynik AI',
  'ai.checkedPre': 'Sprawdzono ',
  'ai.checkedPost': ' slotów',
  'ai.skippedN': ' (+ {n} pominięte)',
  'ai.pillSkipped': 'POMIN',
  'ai.skippedNote': 'ℹ️ {n} {slotWord} pominięto: zdjęcia miały już verdict AI (ok/fail/err). Aby ocenić konkretne zdjęcie ponownie, otwórz je i użyj „Sprawdź ponownie".',
  'ai.slotWord': { one: 'slot', few: 'slotów', many: 'slotów' },
  'ai.errorDetails': 'Szczegóły błędów ({n})',
  'ai.sheetTitle': 'Sprawdzenie AI',
  'ai.noKey': 'Klucz Gemini API nie jest jeszcze ustawiony na serwerze. Skontaktuj się z administratorem.',
  'ai.failHintPre': 'Sloty z verdictem ',
  'ai.failHintPost': ' mają teraz status błędu. Znajdź je w widoku piętra (czerwone ramki) i zrób nowe zdjęcia. Po nowym zdjęciu uruchom AI ponownie.',

  // --- BulkAcceptButton + WeTypeButton ---
  'bulk.scope.slot': 'slot',
  'bulk.scope.group': 'grupę',
  'bulk.scope.floor': 'piętro',
  'bulk.scope.address': 'cały adres',
  'bulk.unknownError': 'Nieznany błąd bulk-override',
  'bulk.btn': '✅ Akceptuj wszystkie ({scope}){count}',
  'bulk.errTitle': '⚠ Błąd bulk-override',
  'bulk.savedTitle': '✅ Bulk override zapisany',
  'bulk.title': 'Akceptuj wszystkie ({scope})',
  'bulk.exPre': 'Akcja oznaczy wszystkie zdjęcia z verdictem ',
  'bulk.exMid': ' jako ',
  'bulk.exPost': ' w obrębie {scope}. Pliki zostaną przemianowane (_Fail.jpg → _ok.jpg) i status slotów zostanie zaktualizowany.',
  'bulk.reasonLabel': 'Powód (opcjonalny, domyślnie auto-fill timestamp + admin login)',
  'bulk.reasonPlaceholder': 'np. False positive Gemini: cement+kabel poprawnie zaszpachlowane',
  'bulk.syncCheckbox': '📤 Po accept: wystartuj sync OneDrive (rclone copy + share link)',
  'bulk.accepting': 'Akceptuję…',
  'bulk.confirm': '✅ Potwierdź',
  'bulk.acceptedPre': 'Zaakceptowano ',
  'bulk.acceptedPost': ' zdjęć',
  'bulk.skipped': ' (+ {n} pominięte, już ok)',
  'bulk.nothingUnverdicted': 'Nic do akceptacji: {n} zdj. bez werdyktu. Uruchom najpierw „Sprawdź AI".',
  'bulk.nothing': 'Nic do akceptacji w tym zakresie (brak zdjęć fail/err i bez werdyktu).',
  'bulk.breakdown': 'Breakdown per slot_kind',
  'bulk.syncStarted': '📤 OneDrive sync wystartowany, share link będzie dostępny w panelu admin po zakończeniu rclone.',
  'bulk.renameWarn': '⚠ Część plików nie została przemianowana (ENOENT lub permission). Verdict zapisany w DB.',
  'bulk.recalcWarn': '⚠ Re-agregacja statusu slotów częściowo failed. Odśwież ekran ręcznie.',
  'bulk.closeRefresh': 'Zamknij i odśwież',
  'wt.typeHeader': 'Typ mieszkania',
  'wt.deviationSuffix': '· odstępstwo od typu adresu',
  'wt.fedFrom': 'zasilane z {ref}',
  'wt.changeHeader': 'Zmień typ mieszkania',
  'wt.current': 'obecny',
  'wt.back': 'Wróć',
  'wt.fedQuestion': 'Zasilane z: które mieszkanie piętro niżej?',
  'wt.next': 'Dalej',
  'wt.confirmHeader': 'Potwierdzenie',
  'wt.saving': 'Zapisuję i przebudowuję sloty…',
  'wt.aria': 'Typ mieszkania: {label}. Tap otwiera opis i zmianę typu.',
  'wt.badgeV1': '🔒 v1',
  'wt.badgeDeviation': 'odstępstwo',
  'wt.badgeDesc': 'opis ›',
  'wt.default': ' (domyślne)',

  // --- OfflineBanner + VersionBanner ---
  'ob.localOn': 'Tryb lokalny włączony: zdjęcia zostają na telefonie, wysyłka wstrzymana.',
  'ob.syncOn': 'Synchronizacja włączona.',
  'ob.photoLost': 'Zdjęcie NIE poszło ({where}): {reason}. Zrób nowe.',
  'ob.lostStrip': '🗑 Usunięto {n} zdjęć utraconych przez system, szczegóły w Serwisie',
  'ob.memory': '⚠ Kolejka zajmuje {mb} pamięci telefonu. Wyślij zdjęcia przy dobrym zasięgu.',
  'ob.reachQ': '📶 Masz zasięg. Włączyć synchronizację?',
  'ob.enableSync': 'Włącz synchronizację',
  'ob.toggleAriaOn': 'Tryb lokalny włączony, tap = włącz synchronizację',
  'ob.toggleAriaOff': 'Włącz Tryb lokalny (zdjęcia zostają na telefonie)',
  'ob.toggleTitleOn': 'Tryb lokalny: wysyłka wstrzymana, ekrany z pamięci telefonu',
  'ob.toggleTitleOff': 'Tryb lokalny: bezpiecznik, gdy tło zawodzi (piwnica, zły zasięg)',
  'ob.localMode': 'Tryb lokalny',
  'ob.localBanner': '🔒 Tryb lokalny: {n} {photos} na telefonie ({mb})',
  'ob.offline': '📵 Offline: zdjęcia zapisane lokalnie ({n} w kolejce)',
  'ob.weakN': '📶 Słaby zasięg, pokazuję ostatni stan ({n} zdj. czeka)',
  'ob.weak': '📶 Słaby zasięg, pokazuję ostatni stan',
  'ob.failed': '⚠ {n} {photos} nie udało się wysłać{waiting}',
  'ob.waiting': ' ({n} czeka)',
  'ob.retry': '↻ Ponów',
  'ob.stall': '⚠ Kolejka stoi: {n} {photos}, {tail}',
  'ob.threshold': '⏳ {n} {photos} ({mb}) czeka na wysłanie',
  'vb.requiredTitle': 'Wymagana aktualizacja{t}',
  'vb.requiredBody': 'Pliki nowej wersji są już w telefonie. Wystarczy jedno tapnięcie, działa też bez internetu. Zdjęcia w kolejce zostają.',
  'vb.reloading': 'Przeładowuję…',
  'vb.haveRequired': 'masz {shell} · wymagane {min}',
  'vb.dismissAria': 'Zamknij (wróci za godzinę)',

  // --- FleetSection + WeekPickerScreen + CustomDropdown ---
  'fleet.renamePrompt': 'Własna nazwa dla „{label}" (max 30 znaków; pusto = usuń):',
  'fleet.title': 'Flota urządzeń',
  'fleet.latestCounter': 'na najnowszej ({latest}): {count}',
  'fleet.minRequired': '· wymagana min. ',
  'fleet.allTeams': 'wszystkie teamy',
  'fleet.noDevices': 'Brak urządzeń (pierwszy puls przychodzi po otwarciu aplikacji w nowej wersji).',
  'fleet.colLabel': 'Etykieta',
  'fleet.colVersion': 'Wersja · SW · pliki',
  'fleet.colQueue': 'Kolejka',
  'fleet.colLocal': 'Lokalny',
  'fleet.colPulse': 'Puls',
  'fleet.colDiag': 'Diagnostyka',
  'fleet.legend': 'czerwony = poniżej wymaganej / instalacja padła / bez pulsu > 4 dni · żółty = pobiera / starsza · zielony = najnowsza w komplecie',
  'fleet.renameTitle': 'Zmień własną nazwę',
  'fleet.firstTeam': 'pierwszy team: {team}',
  'fleet.yes': '🔒 tak',
  'fleet.no': 'nie',
  'fleet.noEntries': 'brak wpisów',
  'wp.current': 'Bieżący',
  'wp.nextWeeks': 'Kolejne tygodnie',
  'dd.placeholder': 'Wybierz…',
  'dd.apply': 'Zastosuj',
  'dd.checkWeek': 'Zaznacz tydzień',

  // --- weekPicker.js ---
  'wp.older': 'Starsze tygodnie',
  'wp.olderTo': 'Starsze tygodnie (do KW {kw}{y})',

  // --- InfoScreen + AdminQueueScreen + SupportLiteScreen ---
  'info.domofon': 'Domofon (nazwiska czytelne)',
  'info.loadFailed': 'Błąd pobierania danych Info',
  'info.saveNoteFailed': 'Nie udało się zapisać notatki',
  'info.entranceTitle': 'Zdjęcia wejścia: obowiązkowe',
  'info.entranceHint': 'Budynek + domofon robisz przy wejściu, zanim wybierzesz typ montażu. Bez oceny AI, komplet odblokowuje wybór typu.',
  'info.complete': '✓ komplet',
  'info.akpTitle': 'AKP\'s: dokumenty',
  'info.noDocs': 'brak dokumentów',
  'info.openExtra': '📷 Otwórz Extra Foto (zdjęcia bez opisu)',
  'info.notizTitle': 'Notiz: Techniker Bemerkung',
  'info.noNotes': 'brak notatek',
  'info.addNoteLabel': 'Dodaj notatkę (dopisywana na końcu, istniejące wpisy bezpieczne)',
  'info.notePlaceholder': 'Twoja notatka…',
  'info.savingNote': 'Zapisywanie…',
  'info.addNote': 'Dodaj notatkę',
  'aq.copyFailed': 'Kopiowanie nie powiodło się: {err}',
  'aq.noAccess': 'Brak dostępu.',
  'aq.diag': 'DIAGNOSTYKA · READ-ONLY',
  'aq.title': 'Kolejka offline',
  'aq.total': 'Razem',
  'aq.pending': 'Czeka',
  'aq.uploading': 'Wysyła',
  'aq.failed': 'Nieudane',
  'aq.refresh': '↻ Odśwież',
  'aq.copied': '✓ Skopiowano',
  'aq.export': 'Eksportuj JSON',
  'aq.empty': 'Kolejka pusta: brak zdjęć oczekujących na wysyłkę.',
  'aq.colAddress': 'Adres / KW',
  'aq.colFloor': 'Piętro',
  'aq.colFile': 'Plik',
  'aq.colSize': 'Rozmiar',
  'aq.colCreated': 'Utworzono',
  'aq.colLastTry': 'Ost. próba',
  'aq.colError': 'Błąd',
  'aq.colLastFailed': 'Ost. nieudany błąd',
  'sl.named': 'Telefon nazwany: {name}',
  'sl.nameRemoved': 'Własna nazwa usunięta',
  'sl.nameFailed': 'Nie udało się zapisać nazwy: {err}',
  'sl.diagFailed': 'Wysyłka diagnostyki nie powiodła się: {err}',
  'sl.weak': 'słaby zasięg',
  'sl.header': 'SERWIS · TEN TELEFON',
  'sl.title': 'FiberOps · Serwis',
  'sl.thisPhone': 'Ten telefon w centrali',
  'sl.noLabel': 'jeszcze bez etykiety',
  'sl.labelHint': 'etykietę nadaje centrala przy pierwszym połączeniu',
  'sl.namePlaceholder': 'Nazwij ten telefon (np. Samsung Kamila)',
  'sl.app': 'Aplikacja',
  'sl.swFiles': 'SW · pliki',
  'sl.net': 'Sieć',
  'sl.queue': 'Kolejka',
  'sl.lastSent': 'Ostatnie wysłane',
  'sl.localOn': '🔒 WŁĄCZONY',
  'sl.localOff': '🔓 wyłączony',
  'sl.localHint': 'Tryb lokalny: zdjęcia zostają na telefonie, zero sieci (np. przed zejściem do piwnicy). Wyłącz po wyjściu na zasięg.',
  'sl.reload': '🔄 Przeładuj do nowej wersji{t}',
  'sl.sending': 'Wysyłanie…',
  'sl.queued': '✓ Zapisana, wyśle się przy zasięgu',
  'sl.diagError': '⚠ Nie udało się, spróbuj przy zasięgu',
  'sl.callHint': 'Gdy dzwonisz do centrali, podaj etykietę z góry ekranu.',

  // --- SupportScreen.jsx ---
  'ss.retryOffline': 'Urządzenie offline. Spróbuj przy zasięgu.',
  'ss.retryBusy': 'Kolejka właśnie wysyła. Poczekaj chwilę.',
  'ss.retryMissing': 'Wpis nie istnieje (mógł się właśnie wysłać).',
  'ss.modeHeader': 'TRYB SERWISOWY · {mode}',
  'ss.modePlus': 'ROZSZERZONY',
  'ss.modeLimited': 'OGRANICZONY',
  'ss.netQueue': 'Sieć i kolejka',
  'ss.namePlaceholder': 'Nazwij ten telefon',
  'ss.version': 'Wersja',
  'ss.queueVal': '{n} zdj. · {mb}',
  'ss.copyJson': 'Kopiuj JSON',
  'ss.colAddress': 'Adres',
  'ss.colAction': 'Akcja',
  'ss.lostTitle': 'Utracone ({n}): treść zniszczona przez system',
  'ss.lostHint': 'Te zdjęcia nie istnieją już w pamięci telefonu (iOS potrafi wyczyścić zawartość kolejki offline). Trzeba je zrobić ponownie.',
  'ss.colTaken': 'Zrobione',
  'ss.colDetected': 'Wykryto',
  'ss.uploadLogTitle': 'Próby wysyłki (ostatnie {n})',
  'ss.colWhen': 'Kiedy',
  'ss.colResult': 'Wynik',
  'ss.colSent': 'Wysłano',
  'ss.colOriginal': 'Oryginał',
  'ss.colTime': 'Czas',
  'ss.colAttempt': 'Próba',
  'ss.footer': 'Widok read-only kolejki TEGO urządzenia. Kolejkę czyści potwierdzony upload oraz automatyczny skan wpisów utraconych (trafiają do rejestru wyżej). Żadna RĘCZNA akcja niczego nie kasuje.',

  // --- SystemSettingsSection.jsx ---
  'sys.windowAll': 'Wszystkie',
  'sys.ttlEod': 'do końca dnia',
  'sys.ttl24h': '24 godziny',
  'sys.ttl7d': '7 dni',
  'sys.kwBack': '{v} KW wstecz',
  'sys.narrowConfirm': 'Zawężasz okno uploadu ({from} → {to}).\n\n⚠ PRZED zawężeniem kolejki technikow muszą być PUSTE: niewysłane wpisy\ndo starych KW utkną jako "failed" (lekcja z 29.08).\n\nKontynuować?',
  'sys.farbeOffConfirm': 'Wyłączasz writeback koloru adresu (PWA_Farbe) do Airtable.\n\nBiuro przestanie widzieć świeży kolor; zmiany zbiorą się w bazie i zostaną\ndopisane po ponownym włączeniu (bez utraty).\n\nKontynuować?',
  'sys.minVerConfirm': 'Ustawiasz wymaganą wersję minimalną = {v}.\n\nTelefony ze starszą skorupą, które mają już KOMPLET nowej wersji, dostaną pełnoekranowe\n„Przeładuj" (jedno tapnięcie, działa bez sieci). Telefony bez kompletu plików pracują dalej\nz banerem „dokończ przy zasięgu". Kolejki zdjęć nietknięte.\n\nKontynuować?',
  'sys.title': 'Ustawienia systemowe · pełny admin',
  'sys.deviationUpload': '⚠ Aktywne odstępstwo: okno uploadu = {v}, {until}{note}',
  'sys.deviationViewer': '⚠ Aktywne odstępstwo: mały admin widzi {label}{detail}',
  'sys.weekWindows': 'Okna tygodni',
  'sys.weekWindowsHint': 'Technicy: ile tygodni wstecz można jeszcze wgrać zdjęcia (default {d1}). Mały admin (Bernard, Damian): ile wstecz i naprzód widać w pickerze KW i na liście adresów (default {d2} / {d3}); pełnego admina nie dotyczy.',
  'sys.colRole': 'rola',
  'sys.colBack': 'wstecz',
  'sys.colFwd': 'naprzód',
  'sys.techs': 'Technicy',
  'sys.uploadWindow': 'okno uploadu',
  'sys.plusOne': '+1 (stałe)',
  'sys.viewer': 'Mały admin',
  'sys.browsing': 'przeglądanie',
  'sys.otherNumber': 'inna liczba…',
  'sys.intRange': 'liczba całkowita {min}–{max}',
  'sys.viewerNow': 'mały admin teraz: {label} · picker {n} pozycji · najstarszy {oldest}',
  'sys.previewPre': 'Po zapisie mały admin zobaczy ',
  'sys.previewN': '{n} pozycji',
  'sys.previewPost': ' ({back} wstecz + bieżący + {fwd} naprzód), najstarszy KW: {oldest}.',
  'sys.previewNarrow': ' Starsze tygodnie znikną z listy i przestaną się otwierać z zapisanych linków.',
  'sys.notePlaceholder': 'Notatka do audytu (po co zmiana?)',
  'sys.saving': 'Zapisywanie…',
  'sys.saveN': 'Zapisz zmiany ({n})',
  'sys.saved': '✓ Zapisano. Obowiązuje od zaraz (cache do 45 s).',
  'sys.farbeHint': 'Kolor adresu w Airtable (PWA_Farbe): zapis przy zmianie koloru + abgleich 04:45.',
  'sys.farbeDeviation': '⚠ Writeback koloru {label}{detail}',
  'sys.writeback': 'Writeback: {label}',
  'sys.off': 'Wyłącz',
  'sys.on': 'Włącz',
  'sys.minHint': 'Wymagana wersja minimalna PWA. Zwykły deploy = tylko baner „Nowa wersja gotowa"; deploy krytyczny (np. zmiana formatu kolejki) = podnieś próg. Blokada TYLKO przy komplecie plików w telefonie.',
  'sys.minBlock': '⚠ Aktywna blokada: {label}{detail}',
  'sys.minLabel': 'min: {v}',
  'sys.latestLine': '· latest na serwerze: {latest} · ten ekran: {app}',
  'sys.minPlaceholder': 'np. {v}',
  'sys.set': 'Ustaw',
  'sys.clear': 'Wyczyść',
  'sys.history': 'Historia zmian ({n})',

  // --- systemSettingsHelpers.js (minRequiredSummary) ---
  'settings.required': 'wymagana {v}',
  'settings.noBlock': 'brak blokady',

  // --- InstallTypeScreen.jsx ---
  'it.T1': 'Rurki',
  'it.T2': 'Komin',
  'it.T3': 'Sufit',
  'it.T4': 'Klatka',
  'it.T5': 'Mieszany',
  'it.step': 'KROK 1/3',
  'it.typeHeader': 'TYP ROZBUDOWY',
  'it.title': 'Wybierz typ rozbudowy',
  'it.infoSub': 'Plany (AKP) · Notatki · Zdjęcia wejścia',
  'it.mandatoryN': 'obowiązkowe {n}/2',
  'it.confirm': 'Potwierdź wybór',

  // --- ErklaerungModal.jsx ---
  'erk.sigMissing': 'Brakuje podpisu klienta. Poproś o podpis w ramce.',
  'erk.sigShort': 'Podpis za krótki (pojedyncza kropka?). Poproś o zamaszysty podpis.',
  'erk.pdfFailed': 'Nie udało się pobrać PDF ({err})',
  'erk.gruendeMissing': 'Zaznacz przynajmniej jeden powód odstępstwa.',
  'erk.andererMissing': 'Pozycja „Anderer Grund” wymaga krótkiego opisu.',
  'erk.titleView': 'Dokument zgody: podpisany',
  'erk.titleForm': 'Zgoda: zmiana miejsca montażu TA',
  'erk.client': 'Klient: ',
  'erk.pdfNeedsOnline': 'Podgląd PDF wymaga połączenia z internetem.',
  'erk.openPdf': '📄 Otwórz PDF',
  'erk.loadingPdf': '⏳ Pobieram PDF…',
  'erk.resign': '✍ Podpisz ponownie (nowy dokument zastąpi ten)',
  'erk.keepNote': 'podpisany dokument zostaje w dokumentacji, nie da się go skasować z aplikacji',
  'erk.formHint': 'Adres, piętro i WE dokłada serwer, wypełniasz tylko dane klienta.',
  'erk.positionLabel': 'Gewünschte Montageposition (opcjonalnie)',
  'erk.positionPlaceholder': 'puste = „wie in der Fotodokumentation festgehalten”',
  'erk.loadingGruende': '⏳ Ładuję pozycje z generatora…',
  'erk.tryAgain': 'Spróbuj ponownie',
  'erk.andererPlaceholder': 'Anderer Grund: krótki opis (1 linia)',
  'erk.generating': '⏳ Generuję dokument…',
  'erk.submit': '✍ Podpisano: wygeneruj i zapisz PDF',
  'erk.backToSigned': '← Wróć do podpisanego dokumentu',

  // --- BuildingConfigScreen.jsx ---
  'bc.decrease': 'Zmniejsz',
  'bc.increase': 'Zwiększ',
  'bc.noWe': 'Brak WE',
  'bc.removeSp': 'Usuń SP',
  'bc.addSp': 'Dodaj SP',
  'bc.parter': 'Parter',
  'bc.floorN': 'Piętro {n}',
  'bc.removeFloor': 'Usuń kondygnację',
  'bc.kellerSub': 'Keller (piwnica)',
  'bc.kgExists': 'KG istnieje',
  'bc.moreClicks': 'jeszcze {n}',
  'bc.typeRowTitle': 'Typ rozbudowy adresu',
  'bc.oldRules': '🔒 stare reguły (v1)',
  'bc.fetchFailed': 'Nie udało się pobrać aktualnej konfiguracji: {err}',
  'bc.removeFloorConfirm': 'Usunąć piętro {floor} i {n} slotów{photos}',
  'bc.withPhotos': ' z {n} zdjęciami?',
  'bc.shrinkConfirm': 'Zmniejszenie liczby WE/SP/GV/APL usunie {n} zdjęć ({floors}). Kontynuować?',
  'bc.forceConfirm': '{msg}\n\nWymusić zapis? Zdjęcia z tych slotów zostaną bezpowrotnie usunięte z aplikacji.',
  'bc.step': 'KROK 2/3 · {type}',
  'bc.header': 'KONFIGURACJA BUDYNKU',
  'bc.title': 'Ile mieszkań (WE) na każdej kondygnacji?',
  'bc.removeFloorBtn': '− Usuń piętro',
  'bc.addFloorBtn': '+ Dodaj piętro',
  'bc.maxFloors': 'Maksymalnie {n} pięter',
  'bc.saveErrorTitle': 'Błąd zapisu',
  'bc.summary': 'Podsumowanie',
  'bc.total': 'Łącznie: ',
  'bc.clearing': 'Czyszczenie…',
  'bc.clearAll': '🗑 Wyczyść wszystko',
  'bc.clearTitle': '⚠ Wyczyścić WSZYSTKO dla tego adresu?',
  'bc.clearPre': 'Zostaną ',
  'bc.clearStrong': 'trwale usunięte',
  'bc.clearLi1': 'wszystkie wykonane zdjęcia tego adresu',
  'bc.clearLi2': 'konfiguracja budynku (typ montażu, piętra, WE)',
  'bc.clearLi3': 'wszystkie sloty fotograficzne',
  'bc.clearP': 'Adres wróci do stanu sprzed konfiguracji, trzeba będzie zacząć od wyboru typu montażu. ',
  'bc.clearStrong2': 'Tej operacji nie można cofnąć.',
  'bc.reasonLabel': 'Powód resetu (audit trail) ',
  'bc.reasonPlaceholder': 'np. test cleanup, misconfig WE count',
  'bc.reasonHint': 'ⓘ Wpisz powód resetu (min 3 znaki)',
  'bc.resetDone': '✓ Reset wykonany ({who})',
  'bc.admin': 'admin',
  'bc.tech': 'technik',
  'bc.photosDeleted': ' · {n} zdjęć usuniętych',
  'bc.slotsDeleted': ' · {n} slotów',
  'bc.backToType': 'Wracam do wyboru typu montażu…',
  'bc.reasonTitle': 'Wpisz powód resetu (min 3 znaki)',
  'bc.clearAllTitle': 'Wyczyść wszystko',
  'bc.clearingShort': 'Czyszczę…',
  'bc.yesClear': 'Tak, wyczyść',

  // --- kody backendu (addytywne, MONIT 0526) ---
  'err.slot_min_photos': 'Slot nie osiągnął minimum zdjęć.',
  'err.config_not_found': 'Adres nie ma jeszcze konfiguracji budynku. Najpierw zapisz wizard.',
  'err.invalid_pin': 'Nieprawidłowy PIN',
  'err.invalid_admin_pin': 'Nieprawidłowy PIN administratora',
  'err.admin_disabled': 'Konto administratora wyłączone',

  // --- reszta (skan kontrolny) ---
  'dd.noOptions': 'Brak opcji',
  'tile.progress': 'Postęp: ',
  'fleet.swInstalling': 'pobiera',
  'fleet.swWaiting': 'czeka',
  'fleet.photosAbbr': 'zdj.',
  'api.offlineNoCache': 'Offline: brak danych w cache',

  // --- pakiet zad. 2+3 ---
  'bs.bs_we_w.t2': 'BS-WEw · Brandschutz mieszkanie → komin',
  'bs.bs_we_w.t4_r': 'BS-WEw · Brandschutz mieszkanie → rewizja na klatce',
  'bs.bs_we_w.t4_s': 'BS-WEw · Brandschutz mieszkanie → klatka',
  'bs.bs_we_w.f': 'BS-WEw · Brandschutz mieszkanie → elewacja',
  'err.airtable_unreachable': 'Nie udało się pobrać listy adresów. Spróbuj ponownie za chwilę.',
  'tasks.loadFailed': 'Nie udało się pobrać listy adresów',
  'tasks.noAddressesNoTeam': 'Brak adresów w tym tygodniu.',

  // --- plan posesji (MONIT 2026-10-03_0903, B0) ---
  'plan.button': 'Plan posesji',
  'plan.buttonSub': 'Hinterhaus, kolejne wejście, kolejny Hof',
  'plan.title': 'Plan posesji',
  'plan.leadHof1': 'Dotknij części, które istnieją. Lewo i prawo patrząc od ulicy. Niżej ustaw liczbę wejść.',
  'plan.leadHofN': 'Hof {n} leży za Hinterhaus podwórza Hof {p}. Zaznacz części, które przy nim stoją.',
  'plan.addHof': '+ Dodaj Hof',
  'plan.hofTopView': 'Hof {n} · widok z góry',
  'plan.topView': 'Plan posesji · widok z góry',
  'plan.street': 'ulica · {street}',
  'plan.streetNoName': 'ulica', // pakiet v81 zad. 4: bez wiszącej kropki, gdy nazwy nie da się ustalić
  'plan.passage': 'przejście z Hof {n}',
  'plan.entrancesTitle': 'Liczba wejść w każdej części',
  'plan.lessEntrances': 'Mniej wejść: {part}',
  'plan.moreEntrances': 'Więcej wejść: {part}',
  'plan.codeLine': 'Kod tej części w nazwach plików: ',
  'plan.backNoSave': 'Wróć bez zapisu',
  'plan.backToList': 'Wróć do listy adresów',
  'plan.backToPlan': 'Wróć do planu posesji',
  // MONIT 2026-10-03_1200 D2: technik widzi „wejścia", nie „sekcje" („sekcja" zostaje słowem roboczym w kodzie)
  'plan.sectionsN': { one: '{n} wejście', few: '{n} wejścia', many: '{n} wejść' },
  'plan.hofsSections': '{h} Hof · {s}',
  'plan.configuredOf': { one: '{n} z {total} skonfigurowane', few: '{n} z {total} skonfigurowane', many: '{n} z {total} skonfigurowanych' },
  'plan.configuredShort': '{n} z {total} skonfig.',
  'plan.configure': 'Skonfiguruj',
  'plan.infoShared': 'Info · wspólne dla całego adresu',
  'plan.change': 'Zmień plan',
  'plan.here': 'Jesteś tutaj',
  'plan.typeWe': '{type} · {n} WE',
  'plan.typeFloorsWe': { one: '{type} · {cellar}{n} kondygnacja · {we} WE', few: '{type} · {cellar}{n} kondygnacje · {we} WE', many: '{type} · {cellar}{n} kondygnacji · {we} WE' },
  'plan.cellarPlus': 'Keller + ',
  'plan.egSubEntry': 'Parter · w tym Gebäude i Domofon',
  'plan.floorSub': 'Piętro {n}',
  'conn.title': 'Połączenie (LsWeg)',
  'conn.sub': 'Trasa kabla do tej części budynku: kanał, rura', // MONIT 2026-10-03_1200 zad. 3 (wzór etykiet LsWeg wg miejsca)
  'plan.aplMoveQ': 'Przenieść APL z {from} tutaj?',
  'plan.aplMoveBody': 'APL jest jeden na adres. W części {from} puste sloty APL znikną, sloty ze zdjęciami zostaną wygaszone, a część dostanie slot Połączenie (LsWeg).',
  'plan.aplMoveOk': 'Przenieś APL',

  // --- plan posesji B2 (MONIT 2026-10-03_1740) ---
  'plan.saved': 'Plan posesji zapisany',
  'plan.saveFailed': 'Nie udało się zapisać planu',
  'plan.loadFailed': 'Nie udało się wczytać planu posesji',
  'err.section_has_photos': 'Części budynku ze zdjęciami usuwa tylko Admin: {list}',
  'err.plan_disabled': 'Plan posesji jest wyłączony. Włącza go Admin w Serwisie.',
  'err.plan_hof_empty_middle': 'Hof w środku nie może być pusty. Najpierw usuń ostatni Hof.',
  'err.plan_too_many_sections': 'Za dużo wejść w planie (najwyżej 100).',
  'err.plan_invalid': 'Plan ma nieprawidłowy układ.',
  'err.plan_hof_numbering': 'Hofy muszą mieć kolejne numery.',
  'err.section_unconfigured': 'Nie wszystkie części budynku są skonfigurowane. Sprawdzenie AI całego adresu dopiero po konfiguracji.',
  'err.section_not_found': 'Tej części budynku nie ma już w planie.',
  'err.apl_move_failed': 'Nie udało się przenieść APL. Spróbuj ponownie.',
  // v79 przypadek brzegowy (meldunek 1315, wariant a): piwnica części bez APL — kabel wchodzi z Połączenia
  'slot.leitungsweg.kg.noApl': 'Trasa kabla w piwnicy · wejście kabla → przebicie w górę',
  'sys.planTitle': 'Plan posesji',
  'sys.planHint': 'Kto tworzy i zmienia plan (Hinterhaus, wejścia, Hof). Adresy, które mają już części budynku, działają zawsze.',
  'sys.planMode.off': 'Wyłączony',
  'sys.planMode.admin': 'Tylko Admin',
  'sys.planMode.all': 'Wszyscy',
  // Pakiet v81 (MONIT 2026-10-04_0101 zad. 7-9): symbole mieszkań, przełącznik w Serwisie, opis dla czytnika ekranu.
  'sys.weSymbolTitle': 'Symbol mieszkania',
  'sys.weSymbolHint': 'Jak pokazywać mieszkania na kafelkach. Wspólne dla całej firmy: wszyscy widzą to, co ustawi Admin.',
  'sys.weSymbol.house': 'Domki',
  'sys.weSymbol.door_building': 'Drzwi w widoku budynku',
  'sys.weSymbol.door_all': 'Drzwi wszędzie',
  // Pakiet v81 zad. 14 (MONIT 2026-10-04_1213): linie w tle per motyw (nazwy motywów: theme.lightTitle / theme.darkTitle).
  'sys.fiberBgTitle': 'Linie w tle',
  'sys.fiberBgHint': 'Animowane linie w tle ekranów. Osobno dla jasnego i ciemnego motywu, wspólne dla całej firmy: wszyscy widzą to, co ustawi Admin.',
  'sys.fiberOn': 'Włączone',
  'sys.fiberOff': 'Wyłączone',
  'weSym.count': { one: '1 mieszkanie', few: '{n} mieszkania', many: '{n} mieszkań' },
  'weSym.st.ai_verified': '{n} sprawdzone',
  'weSym.st.verified': '{n} komplet',
  'weSym.st.kunde_nicht_da': '{n} KND',
  'weSym.st.in_progress': '{n} w toku',
  'weSym.st.ai_error': '{n} błąd AI',
  'weSym.st.empty': '{n} puste',
  // MONIT 2026-10-04_1357 (FAZA A, plansze): numeracja przez całą posesję, plan spawów w APL, slot „APL otwarty".
  'plan.floorSubWe': 'Piętro {n} · {we}',
  'splice.button': 'Plan spawów',
  'splice.title': 'Plan spawów',
  'splice.count': { one: '1 spaw', few: '{n} spawy', many: '{n} spawów' },
  'splice.cassettes': { one: '1 kaseta po 3', few: '{n} kasety po 3', many: '{n} kaset po 3' },
  'splice.introPre': 'Naklejka = piętro-mieszkanie, np. ',
  'splice.introOrder': '. Kolejność: piętro po piętrze, na piętrze {order}. Kodu budynku na naklejce nie ma.',
  'splice.unconfigured': 'Nie wszystkie części budynku są skonfigurowane: plan może się jeszcze zmienić.',
  'splice.howBtn': 'Jak opisać kasetę',
  'splice.fromBottom': 'Kasety liczymy od dołu: kaseta 1 leży na samym dole. Dotknij kasety, żeby ją otworzyć.',
  'splice.top': 'Góra stosu',
  'splice.topLast': 'ostatnia kaseta',
  'splice.bottom': 'Dół stosu',
  'splice.bottomFirst': 'kaseta 1',
  'splice.cassette': 'Kaseta {n}',
  'splice.open': 'otwarta',
  'splice.twoFloors': 'dwa piętra na jednej kasecie',
  'splice.empty': 'Brak mieszkań w konfiguracji. Plan spawów powstanie po konfiguracji budynku.',
  'splice.help.title': 'Jak opisać kasetę',
  'splice.help.r1b': 'Kasety od dołu.',
  'splice.help.r1': ' Kaseta 1 na samym dole stosu. Na kasecie zawiasy u góry, spawy od góry 1, 2, 3.',
  'splice.help.r2b': 'Jedna naklejka na spaw',
  'splice.help.r2': ', format piętro-mieszkanie, np. 001-004.',
  'splice.help.r3b': '3 cyfry, myślnik, 3 cyfry.',
  'splice.help.r3': ' EG = 000, OG.1 = 001, OG.4 = 004, piwnica = 099, WE4 = 004.',
  'splice.help.r4b': 'Numer z planu posesji:',
  'splice.help.r4': ' HH-L na OG.1 ma WE4 i WE5, nie WE1 i WE2.',
  'splice.help.r5b': 'Bez kodu budynku',
  'splice.help.r5': ' na naklejce. Szary dopisek (np. „HH-L WE4") jest tylko na ekranie.',
  'splice.help.good': 'DOBRZE',
  'splice.help.bad': 'ŹLE',
  'apl.cableFlats': 'Kable z mieszkań wchodzą od dołu, po prawej stronie.',
  'apl.cableNe3': 'NE3 wchodzi od dołu, po lewej stronie.',
  'apl.cableFromStreet': 'z ulicy',
  'apl.cableFromFlats': 'z mieszkań',
  'apl.cableAria': 'Schemat APL: NE3 od dołu po lewej, kable z mieszkań od dołu po prawej',
  // v82 (MONIT 2026-10-04_1357, R3 + dopisek HQ, Zasada 4): odmowy zapisu planu i konfiguracji.
  // N4 (MONIT 2026-10-04_1646 Z5): odmowa dla technika uzupełniona o „Zmianę może wykonać Admin."
  'err.we_numbers_shift': 'Ta zmiana przesunęłaby numery mieszkań, które mają już zdjęcia: {list}. Takiej zmiany nie zapisujemy, żeby zdjęcia i naklejki zostały zgodne. Zmianę może wykonać Admin.',
  'err.we_numbers_shift_generic': 'Ta zmiana przesunęłaby numery mieszkań, które mają już zdjęcia. Takiej zmiany nie zapisujemy. Zmianę może wykonać Admin.',
  'err.we_numbers_shift_clear_admin': 'Wyczyszczenie tej części przesunęłoby numery mieszkań, które mają już zdjęcia: {list}. Tego nie dałoby się cofnąć, więc „Wyczyść wszystko" nie zostało wykonane. Najpierw zmniejsz konfigurację tej części do 0 mieszkań i zapisz (z przenumerowaniem), potem „Wyczyść wszystko".',
  'err.we_numbers_shift_clear_admin_generic': 'Wyczyszczenie tej części przesunęłoby numery mieszkań, które mają już zdjęcia. Tego nie dałoby się cofnąć, więc „Wyczyść wszystko" nie zostało wykonane. Najpierw zmniejsz konfigurację tej części do 0 mieszkań i zapisz (z przenumerowaniem), potem „Wyczyść wszystko".',
  'err.plan_hof_admin_only': 'Nowy Hof dodaje tylko Admin.',
  'splice.loadFailed': 'Nie udało się wczytać konfiguracji. Otwórz adres raz z zasięgiem, potem plan działa bez sieci.',
  // N4 (MONIT 2026-10-04_1646): przenumerowanie mieszkań (Admin): podgląd na sucho, podsumowanie, stan adresu.
  'rn.title': 'Przenumerowanie mieszkań',
  'rn.kicker': 'Podgląd, nic nie jest zapisane',
  'rn.intro.config': 'Ta zmiana przesuwa numery mieszkań, które mają już zdjęcia. Nic nie zapisujemy, dopóki nie potwierdzisz.',
  'rn.intro.align': 'Nazwy plików mają stare numery mieszkań. Przenumerowanie dopasuje je do planu posesji. Nic nie zapisujemy, dopóki nie potwierdzisz.',
  'rn.intro.undo': 'Cofnięcie przywraca numery i nazwy plików sprzed ostatniego przenumerowania oraz poprzedni plan albo konfigurację.',
  'rn.filesTitle': 'Pliki: stary numer → nowy',
  'rn.files': { one: '1 plik', few: '{n} pliki', many: '{n} plików' },
  'rn.archived': { one: '1 archiwalny', few: '{n} archiwalne', many: '{n} archiwalnych' },
  'rn.onedrive': '{n} w OneDrive',
  'rn.pdf': 'PDF Erklärung',
  'rn.total': 'Razem: {files} · OneDrive: {od} · PDF: {pdf}',
  'rn.noFiles': 'Żaden plik nie zmienia nazwy.',
  'rn.stickersTitle': 'Naklejki APL do przeklejenia',
  'rn.stickersNone': 'Żadna naklejka w APL się nie zmienia.',
  'rn.cassetteMove': 'kaseta {a} → {b}',
  'rn.cassette': 'kaseta {a}',
  'rn.stickerNew': 'nowy spaw',
  'rn.stickerRemoved': 'spaw znika',
  'rn.stickersMoved': { one: '1 spaw zmienia kasetę bez zmiany naklejki (szczegóły w planie spawów).', few: '{n} spawy zmieniają kasetę bez zmiany naklejki (szczegóły w planie spawów).', many: '{n} spawów zmienia kasetę bez zmiany naklejki (szczegóły w planie spawów).' },
  'rn.splicesTotal': 'Spawy: {a} → {b} · kasety: {c} → {d}',
  'rn.skipped': { one: '1 plik ma nazwę bez numeru mieszkania i zostaje bez zmian.', few: '{n} pliki mają nazwę bez numeru mieszkania i zostają bez zmian.', many: '{n} plików ma nazwę bez numeru mieszkania i zostaje bez zmian.' },
  'rn.vpsMissing': { one: '1 pliku nie ma na VPS (nazwa w bazie i tak się zmieni).', few: '{n} plików nie ma na VPS (nazwy w bazie i tak się zmienią).', many: '{n} plików nie ma na VPS (nazwy w bazie i tak się zmienią).' },
  'rn.blocked': 'Przenumerowanie zablokowane: {why}. Nic nie zostanie zapisane.',
  'rn.block.cycle': 'dwa pliki zamieniłyby się nazwami',
  'rn.block.path_outside_root': 'plik spoza katalogu zdjęć',
  'rn.block.name_taken': 'nowa nazwa jest już zajęta przez inne zdjęcie',
  'rn.block.target_exists': 'plik o nowej nazwie już leży na VPS',
  'rn.noUndo': 'Tej operacji nie da się cofnąć: „Wyczyść wszystko" usuwa zdjęcia tej części.',
  'rn.lockInfo': 'Na czas przenumerowania zdjęcia tego adresu czekają w kolejce telefonu (kilka sekund).',
  'rn.confirm.config': 'Przenumeruj i zapisz',
  'rn.confirm.align': 'Przenumeruj',
  'rn.confirm.undo': 'Cofnij przenumerowanie',
  'rn.busy': 'Przenumerowuję…',
  'rn.changed': 'W międzyczasie zmieniły się zdjęcia albo plan. Sprawdź nowy podgląd.',
  'rn.failed': 'Przenumerowanie przerwane, nazwy wróciły do stanu sprzed operacji. Nic nie zginęło.',
  'rn.failedAttention': 'Przenumerowanie przerwane, części nazw nie udało się przywrócić. Pełna lista jest w dzienniku operacji, zgłoś to Martinowi.',
  'rn.addressBusy': 'Na tym adresie trwa inna operacja. Spróbuj za chwilę.',
  'rn.sum.title': 'Przenumerowano',
  'rn.sum.titleUndo': 'Cofnięto przenumerowanie',
  'rn.sum.files': { one: 'Zmieniona nazwa: 1 plik', few: 'Zmienione nazwy: {n} pliki', many: 'Zmienione nazwy: {n} plików' },
  'rn.sum.stickersHint': 'Pokaż tę listę technikowi przy APL (można zrobić zrzut ekranu).',
  'rn.sum.odRunning': 'OneDrive: przenoszę pliki…',
  'rn.sum.odDone': 'OneDrive: gotowe',
  'rn.sum.odNone': 'OneDrive: nic do przeniesienia',
  'rn.sum.odPending': { one: 'OneDrive: 1 plik czeka, ponowienie przy najbliższym syncu', few: 'OneDrive: {n} pliki czekają, ponowienie przy najbliższym syncu', many: 'OneDrive: {n} plików czeka, ponowienie przy najbliższym syncu' },
  'rn.sum.done': 'Gotowe',
  'rn.st.title': 'Numery mieszkań',
  'rn.st.alignOk': 'Nazwy plików zgodne z planem posesji.',
  'rn.st.alignTodo': { one: '1 plik ma stary numer mieszkania.', few: '{n} pliki mają stary numer mieszkania.', many: '{n} plików ma stary numer mieszkania.' },
  'rn.st.alignBtn': 'Pokaż podgląd',
  'rn.st.last': 'Ostatnie przenumerowanie',
  'rn.st.none': 'Na tym adresie nie było jeszcze przenumerowania.',
  'rn.st.open': 'Podsumowanie',
  'rn.st.by': '{who} · {when}',
  'rn.kind.config': 'Zmiana konfiguracji',
  'rn.kind.plan': 'Zmiana planu',
  'rn.kind.clear': 'Wyczyść wszystko',
  'rn.kind.align': 'Dopasowanie nazw',
  'rn.kind.undo': 'Cofnięcie',
  'rn.status.done': 'wykonane',
  'rn.status.undone': 'cofnięte',
  'rn.status.failed_reverted': 'przerwane, cofnięte',
  'rn.status.needs_attention': 'przerwane, do sprawdzenia',
  'rn.status.running': 'w toku',
  'rn.undoNo.no_op': 'Brak operacji do cofnięcia.',
  'rn.undoNo.last_is_undo': 'Ostatnia operacja to cofnięcie.',
  'rn.undoNo.clear_not_undoable': '„Wyczyść wszystko" nie da się cofnąć.',
  'rn.undoNo.not_done': 'Operacja nie została zakończona.',
  'rn.undoNo.onedrive_running': 'Najpierw musi skończyć się przenoszenie w OneDrive.',
  'rn.undoNo.changed_since': 'Po przenumerowaniu zmieniono plan albo konfigurację.',
  'rn.undoNo.section_has_photos': 'Część ma już nowe zdjęcia.',
  'rn.undoNo.not_last': 'Cofnąć można tylko ostatnią operację.',
  'rn.undoNo.no_before_state': 'Brak zapisanego stanu sprzed operacji.',
  'rn.adminOnly': 'Przenumerowanie mieszkań wykonuje tylko Admin.',
  'plan.renumber': 'Numery mieszkań',
  // ─── Auskundung E1 (MONIT 2026-10-10_1515): lista terminów AK technika ───
  'ak.title': 'Auskundung',
  'ak.allWeek': 'Cały tydzień',
  'ak.today': 'dziś',
  'ak.pickDay': 'Dzień tygodnia',
  'ak.pickWeek': 'Tydzień (KW)',
  'ak.kunde': 'Kunde: {k}',
  'ak.taskNr': 'AK_Task-Nr',
  'ak.copy': 'Kopiuj',
  'ak.copied': 'Skopiowano',
  'ak.copyAria': 'Kopiuj numer tasku {tsk}',
  'ak.copiedToast': '{tsk} skopiowany. Otwórz Zinier i wklej numer w wyszukiwarce tasków.',
  'ak.copyFallback': 'Schowek niedostępny: numer {tsk} jest zaznaczony, skopiuj go ręcznie.',
  'ak.storniert': 'Task w FSM stornowany',
  'ak.info': 'AK Info',
  'ak.infoEmpty': 'brak uwag biura',
  'ak.akpStatus': 'AKP Status',
  'ak.statusNone': 'brak',
  'ak.markConfig': 'Konfiguracja',
  'ak.markPhotos': 'Zdjęcia wejść {x}/{y}',
  'ak.markStatus': 'Status',
  'ak.terms': { one: '{n} termin', few: '{n} terminy', many: '{n} terminów' },
  'ak.noTerms': 'Brak terminów Auskundung w tym dniu.',
  'ak.noTermsWeek': 'Brak terminów Auskundung w tym tygodniu.',
  'ak.loadFailed': 'Nie udało się pobrać terminów Auskundung.',
  'ak.backToList': 'Wróć do listy Auskundung',
  // E2 (MONIT 2026-10-10_1735): konfiguracja przez AK; zdjęcia i notatka nadal od następnej wersji.
  'ak.notOnListTitle': 'Adres spoza Twojej listy Auskundung',
  'ak.notOnListText': 'Konfigurację zapiszesz tylko dla adresów z Twoich terminów Auskundung. Jeśli termin jest, a adres się nie otwiera, zadzwoń do biura.',
  'ak.photosNextVersion': 'Zdjęcia technika Auskundung wejdą w następnej wersji. Teraz zapisz konfigurację budynku.',
  'ak.configSavedToList': 'Konfiguracja zapisana. Wracam na listę Auskundung.',
  'ak.configSavedToPlan': 'Konfiguracja zapisana. Skonfiguruj kolejne wejście na planie.',
  'ak.tabTerms': 'Terminy',
  // E3 (MONIT 2026-10-10_2340): zdjęcia technika Auskundung (ekran AK-3, przedrostek AK_).
  'ak.ph.title': 'Zdjęcia wejść',
  'ak.ph.lead': 'Każde wejście: budynek z zewnątrz i domofon. Wymagane do zamknięcia terminu.',
  'ak.ph.prefix': 'Pliki z Auskundung dostają przedrostek',
  'ak.ph.count': 'Zdjęcia: {x} z {y}',
  'ak.ph.all': 'Wszystkie sloty',
  'ak.ph.open': 'Otwórz zdjęcia wejść',
  'ak.ph.unconfigured': 'Wejście jeszcze bez konfiguracji. Zdjęcie trafi do slotu po zapisaniu konfiguracji.',
  'ak.ph.loadFailed': 'Nie udało się pobrać zdjęć wejść.',
  'err.ak_next_version': 'Ta funkcja dla technika Auskundung wejdzie w następnej wersji.',
  'err.ak_not_on_list': 'Ten adres nie jest na Twojej liście Auskundung.',
  // E5 (MONIT 2026-10-11_0125): Admin, tryb MO / AK (guzik w nagłówku), karta AK Admina, „Wyślij teraz” zdjęć AK.
  'ak.adm.toAk': 'Przełącz na terminy Auskundung',
  'ak.adm.toMo': 'Przełącz na terminy montażu',
  'ak.adm.allAkTeams': 'Wszystkie teamy AK',
  'ak.adm.noAkTeam': 'Bez teamu AK',
  'ak.adm.teamAria': 'Team Auskundung',
  'ak.adm.sendNow': 'Wyślij teraz',
  'ak.adm.sendNowTitle': 'Wyślij zdjęcia Auskundung tego adresu na OneDrive (ten sam sync co w trybie MO)',
  'ak.infoN': 'AK Info · {n}',
  // E4 (MONIT 2026-10-11_1415): status terminu AK (ekran AK-5), notatka AK odblokowana
  'ak.notePrefixHint': 'Notatka trafi do biura z oznaczeniem „AK:”.',
  'ak.st.button': 'Status terminu',
  'ak.st.change': 'Popraw status',
  'ak.st.title': 'Wynik Auskundung',
  'ak.st.qHeld': 'Termin się odbył?',
  'ak.st.yes': 'Tak',
  'ak.st.no': 'Nie',
  'ak.st.qSign': 'Jest podpis klienta?',
  'ak.st.signYes': 'Jest podpis',
  'ak.st.signNo': 'Brak podpisu',
  'ak.st.reason': 'Powód',
  'ak.st.r.kunde_nicht_da': 'Klient nieobecny',
  'ak.st.r.kein_zugang': 'Brak dostępu',
  'ak.st.r.sonstiges': 'Inny powód',
  'ak.st.notePh': 'Notatka (opcjonalnie)',
  'ak.st.willSet': 'AKP Status zostanie ustawiony na',
  'ak.st.hintDone': 'Bez podpisu status to „Termin erledigt ohne Unterschrift”. Statusów biura i FSM technik nie zmienia.',
  'ak.st.hintNotDone': 'Powód i notatka trafiają do notatki technika z oznaczeniem AK.',
  'ak.st.hintNoFsm': 'Termin nie miał tasku w FSM: do notatki technika trafi dopisek „Termin durchgeführt ohne FSM-Task”.',
  'ak.st.save': 'Zapisz',
  'ak.st.saving': 'Zapisuję…',
  'ak.st.saved': 'Status zapisany: {label}',
  'ak.st.savedNoteFail': 'Status zapisany, ale notatka nie dotarła do Airtable. Dopisz ją w Info albo zadzwoń do biura.',
  'ak.st.locked': 'Status ustawia biuro / FSM',
  'ak.st.lockedConflict': 'Biuro / FSM ustawiło już status „{label}”. Nic nie zapisano.',
  'ak.st.failed': 'Nie udało się zapisać statusu. Spróbuj ponownie.',
  'ak.st.offline': 'Bez internetu status nie zostanie zapisany. Spróbuj, gdy wróci zasięg.',
  'ak.st.by': 'ustawił: {by} · {at}',
  'ak.st.resConflict': 'ostatnia próba odrzucona: status biura / FSM',
  'ak.st.resError': 'ostatni zapis do Airtable nieudany',
  'ak.st.noteFailed': 'notatka nie trafiła do Airtable',
  'sync.ak.none': 'AK: brak zdjęć Auskundung do wysłania',
  'sync.ak.open': '⏳ AK: wstrzymane do zamknięcia terminu (konfiguracja {cfg} · zdjęcia wejść {x}/{y} · status {st})',
  'sync.ak.renumber': '⏳ AK: wstrzymane, trwa przenumerowanie mieszkań',
  'sync.ak.failedMarks': 'AK ⚠ nie udało się sprawdzić stanu terminu',
  'sync.ak.withErrors': 'AK ⚠ skopiowane {synced}/{total}, błędy: {errs}',
  'sync.ak.copied': '✅ AK: skopiowane {synced}/{total}',
  'sync.ak.allDone': '✅ AK: wszystko już na OneDrive',
  // E6 (MONIT 2026-10-13_0950): AK Info = Bemerkung + streszczenie (karta, okno AK-9, Info adresu).
  'ak.ai.titleAddr': 'AK Info · {addr}',
  'ak.ai.termin': 'Auskundung Termin {t}',
  'ak.ai.person': 'Osoba na miejscu',
  'ak.ai.call': 'Zadzwoń',
  'ak.ai.callAria': 'Zadzwoń pod {num}',
  'ak.ai.otherPhones': 'Inne numery w treści',
  'ak.ai.place': 'Miejsce spotkania i dostęp',
  'ak.ai.last': 'Ostatnia uwaga biura',
  'ak.ai.none': 'brak w treści',
  'ak.ai.source': 'Streszczenie z pola Bemerkung (Airtable), stan z {at}.',
  'ak.ai.skipped': 'Pominięte: próby kontaktu {k}, wpisy starsze niż termin {s}.',
  'ak.ai.doubt': 'W razie wątpliwości czytaj pełną treść niżej.',
  'ak.ai.pending': 'Streszczenie w przygotowaniu (treść w Airtable się zmieniła). Poniżej pełna treść.',
  'ak.ai.error': 'Streszczenie niedostępne. Poniżej pełna treść z Airtable.',
  'ak.ai.read': 'Bemerkung odczytany z Airtable {at}.',
  'ak.ai.refresh': 'Odśwież',
  'ak.ai.refreshing': 'Odświeżam…',
  'ak.ai.refreshWait': 'Odśwież ponownie za {s} s',
  'ak.ai.refreshFailed': 'Nie udało się odświeżyć (brak zasięgu?). Widzisz ostatni stan.',
  'ak.ai.full': 'Pełna treść Bemerkung · wpisy: {n}',
  'ak.ai.dimContact': 'próba kontaktu',
  'ak.ai.dimOld': 'starsze niż termin',
  'ak.ai.phoneAria': 'w uwagach jest numer telefonu',
  'ak.ai.loading': 'wczytuję uwagi biura…',
  'ak.ai.offline': 'uwagi biura po połączeniu',
  'ak.ai.openAria': 'Otwórz AK Info: {n} wpisów biura',
  'info.bemTitle': 'Uwagi biura (Bemerkung)',
  'info.bemOnlyAk': 'tylko AK',
  'info.bemOpen': 'Otwórz AK Info',
  'info.bemEmpty': 'Brak uwag biura w polu Bemerkung.',
  'ak.ai.phones': 'Numery telefonu w treści',
  // E7 (MONIT 2026-10-13_1130): mały admin w trybie AK, „Przekaż termin”, Serwis.
  'ak.vw.readOnly': 'tylko podgląd',
  'ak.vw.teamLock': 'team {team}',
  'ak.vw.acting': 'Działasz jako {team}: pełne prawa na terminach tego teamu, pozostałe teamy tylko do podglądu.',
  'ak.vw.noLink': 'Konto bez przypisanego teamu AK: tryb AK tylko do podglądu (przypisanie ustawia Admin w Serwisie).',
  'ak.vw.linkedInactive': 'Team {team} jest nieaktywny w Airtable: tryb AK tylko do podglądu.',
  'ak.tr.button': 'Przekaż termin',
  'ak.tr.title': 'Przekaż termin',
  'ak.tr.now': 'Teraz:',
  'ak.tr.pick': 'Do którego teamu AK?',
  'ak.tr.disabledInService': 'wyłączony w Serwisie',
  'ak.tr.noTargets': 'Brak innych włączonych teamów AK (Serwis → Mały admin · tryb AK).',
  'ak.tr.confirm': 'Przekazać {street} ({when}) z {from} do {to}?',
  'ak.tr.hint': 'Biuro zobaczy zmianę w Airtable (AK Teamy) i linię w notatce technika. Zdjęcia już zrobione zostają przy adresie.',
  'ak.tr.back': 'Wstecz',
  'ak.tr.save': 'Przekaż',
  'ak.tr.saving': 'Przekazuję…',
  'ak.tr.done': 'Termin przekazany: {to}',
  'ak.tr.noteFail': 'Termin przekazany, ale linia w notatce technika się nie zapisała.',
  'ak.tr.errOffline': 'Bez internetu termin nie zostanie przekazany. Spróbuj, gdy wróci zasięg.',
  'ak.tr.errConflict': 'Biuro zmieniło w międzyczasie team tego terminu. Lista odświeżona, nic nie zapisano.',
  'ak.tr.errLocked': 'Status terminu ustawiło biuro / FSM: przekazanie zablokowane.',
  'ak.tr.errWindow': 'Termin poza oknem listy AK.',
  'ak.tr.errDisabled': 'Team AK wyłączony w Serwisie albo nieaktywny.',
  'ak.tr.errScope': 'To nie jest termin Twojego teamu AK.',
  'ak.tr.errFailed': 'Nie udało się przekazać terminu. Spróbuj ponownie.',
  'sys.vak.title': 'Mały admin · tryb AK',
  'sys.vak.linkTitle': 'Działa jako team AK',
  'sys.vak.linkHint': 'Na terminach tego teamu mały admin ma pełne prawa technika AK (zapisy pod nazwą teamu). „Brak” = tryb AK tylko do podglądu.',
  'sys.vak.none': 'brak',
  'sys.vak.inactive': 'nieaktywny',
  'sys.vak.noPin': 'kod logowania nieustawiony na serwerze',
  'sys.vak.visTitle': 'Teamy AK widoczne dla małego admina',
  'sys.vak.visHint': 'Nowe teamy są domyślnie wyłączone. Własny team małego admina widać zawsze. Ta sama lista = teamy, którym można przekazać termin.',
  'sys.vak.visOn': 'Włączony',
  'sys.vak.visOff': 'Wyłączony',
  'sys.vak.noTeams': 'Brak teamów AK w pamięci serwera (tabela AK Teamy).',
  'sys.vak.winTitle': 'Okno małego admina w trybie AK',
  'sys.vak.winHint': 'Niezależne od okna MO. Pełnego Admina nie dotyczy.',
};
